/* eslint-disable prefer-const */
/*
* slotmanagement.js
*
* Description: Holds 'Stores' Logic for Module:'Slotmanagement'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Flights"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact: http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> slotmanagement - FlightsTable ----------------------
    slotmanagement_flights: [],
    slotmanagement_flights_Filtered: [],
    slotmanagement_flightsTable_selectedFlights: [],
    slotmanagement_flightsTable_rotations: [],
    slotmanagement_flightsTable_rotations_chain: [],
    slotmanagement_flightsTable_rotations_chain_Filtered: [],
    // >>> slotmanagement - search/filter ---------------------
    slotmanagement_filterTerm: {},

    // >>> slotmanagement - SlotsTable ------------------------
    slotmanagement_slotsTable_selectedSlots: [],
    slotmanagement_slotsTable_getSlots: [],
    slotmanagement_slotsTable_slots: [],
    slotmanagement_slotsTable_slots_Filtered: [],
    slotmanagement_slotsTable_Rotations_Chain_Filtered: [],
    slotmanagement_slotsTable_rotations_chain: []

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Slotmanagement' -
    ***************************************************************************/
    /***************************************************************************
    * get_Flights()
    *
    * Desc:
    * Note:
    *
    */
     get_Flights: state => {

        return state.slotmanagement_flights;

    }, // eo function get_Blocktimes()


    /***************************************************************************
    * get_Flights_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_Flights_Filtered: state => {

        return state.slotmanagement_flights_Filtered;

    }, // eo function get_Flights_Filtered()

    /***************************************************************************
    * get_Flights_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_FlightTable_SelectedFlights: state => {

        return state.slotmanagement_flightsTable_selectedFlights;

    }, // eo function get_Flights_Filtered()

    /***************************************************************************
    * get_FlightTable_Rotations()
    *
    * Desc:
    * Note:
    *
    */
    get_FlightTable_Rotations: state => {

        return state.slotmanagement_flightsTable_rotations;

    }, // eo function get_FlightTable_Rotations()

    /***************************************************************************
    * get_FlightTable_Rotations_Chain()
    *
    * Desc:
    * Note:
    *
    */
    get_FlightTable_Rotations_Chain: state => {

        return state.slotmanagement_flightsTable_rotations_chain;

    }, // eo function get_FlightTable_Rotations_Chain()

    /***************************************************************************
    * get_FlightTable_Rotations_Chain_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_FlightTable_Rotations_Chain_Filtered: state => {

        return state.slotmanagement_flightsTable_rotations_chain_Filtered;

    }, // eo function get_FlightTable_Rotations_Chain_Filtered()


    /***************************************************************************
    * get_SlotsTable_SelectedSlots()
    *
    * Desc:
    * Note:
    *
    */
    get_SlotsTable_SelectedSlots: state => {

        return state.slotmanagement_slotsTable_selectedSlots;

    }, // eo function get_SlotsTable_SelectedSlots()

    /***************************************************************************
    * get_SlotsTable_getSlots()
    *
    * Desc:
    * Note:
    *
    */
    get_SlotsTable_getSlots: state => {

        return state.slotmanagement_slotsTable_getSlots;

    }, // eo function get_SlotsTable_getSlots()

    /***************************************************************************
    * get_SlotsTable_Rotations_Chain()
    *
    * Desc:
    * Note:
    *
    */
    get_SlotsTable_Rotations_Chain: state => {

        return state.slotmanagement_slotsTable_rotations_chain;

    }, // eo function get_SlotsTable_Rotations_Chain()

    /***************************************************************************
    * slotmanagement_slotsTable_Rotations_Chain_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_SlotsTable_Rotations_Chain_Filtered: state => {

        return state.slotmanagement_slotsTable_Rotations_Chain_Filtered;

    } // eo function slotmanagement_slotsTable_Rotations_Chain_Filtered()

};





//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Slotmanagement', Call: Get Slotmanagement
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getFlights()
    *
    * Desc: Save Flights (unfiltered).
    * Note:
    *
    */
    mut_call_getFlights: (state, payload) => {

        payload.context.commit('mut_call_rebuildFlights', { payload: payload.payload, context: payload.context });

    }, // eo function mut_call_getFlights()

    /***************************************************************************
    * mut_call_slotmanagement_updateFlights()
    *
    * Desc: Save updated Flights.
    * Note:
    *
    */
    mut_call_slotmanagement_updateFlights: (state, payload) => {

        let flights = [];

        payload.payload.forEach((flight) => {
            flight.wasEdited = true;
        });

        // >>> New Legs into flights_Legs State ------------------------
        flights =
            state.slotmanagement_flights
                .filter(
                    flight =>
                        payload.payload
                            .find(payloadflight => payloadflight.idFlight === flight.idFlight) === undefined
                ); // delete "old" updated flights

        flights = flights.concat(payload.payload); // add "new" updated flights
        payload.context.commit('mut_call_rebuildFlights', { payload: flights, context: payload.context });
        eventBus.$emit('flightsUpdated', payload.payload);

    }, // eo function mut_call_slotmanagement_updateFlights()

    /***************************************************************************
    * mut_call_rebuildFlights()
    *
    * Desc: Save updated Flights.
    * Note:
    *
    */
    mut_call_rebuildFlights: (state, payload) => {

        // >>> Flights --------------------------------------
        payload.context.commit('mut_buildEvents', { payload: payload.payload, context: payload.context });
        payload.context.commit('mut_filter_Flights'); // rebuild
        // >>> Rotations ------------------------------------
        payload.context.commit('mut_buildRotations');
        payload.context.commit('mut_filter_Rotations');
        // >>> Warnings -------------------------------------
        payload.context.commit('mut_createWarnings');

    }, // eo function mut_call_rebuildFlights()

    /***************************************************************************
    * mut_buildEvents()
    *
    * Desc: Build Flight Events for Flight List.
    * Note:
    *
    */
    mut_buildEvents: (state, payload) => {

        let flights = [];
        flights = payload.payload.filter(leg => leg.name !== 'AC' && leg.name !== 'BA'); // save
        // flights = flights.filter(flight => !flight.deleted);
        flights = flights.filter(flight => flight.flightModus !== 'E');
        flights = flights.filter(flight => flight.flightModus !== 'V');

        state.slotmanagement_flights = flights.map(flight => {

            flight.aircraft = payload.context.rootState.shared.people_aircraftConfigs.find(a => a.id === flight.idAircraftConfig);
            flight.aptFrom.details = payload.context.rootState.airports.airports_airports.find(a => a.iataCode === flight.aptFrom.aptCode);
            flight.aptTo.details = payload.context.rootState.airports.airports_airports.find(a => a.iataCode === flight.aptTo.aptCode);

            if (flight.depSlotStatus === null && flight.dep_slt_time) {
                flight.depSlotStatus = 'confirmed';
            }
            if (flight.arrSlotStatus === null && flight.arr_slt_time) {
                flight.arrSlotStatus = 'confirmed';
            }
            // historically conditioned.. mainServiceType was once type boolean
            if (flight.mainServiceType === '0' || flight.mainServiceType === null) {
                flight.mainServiceType = 'C';
            }
            if (flight.mainServiceType === '1') {
                flight.mainServiceType = 'J';
            }
            if (/F$/.test(flight.flightNo)) {
                flight.mainServiceType = 'P';
            }
            return flight;
        });
        // state.slotmanagement_flights_Filtered = state.slotmanagement_flights;

    }, // eo function mut_buildEvents()

    /***************************************************************************
    * mut_buildRotations()
    *
    * Desc: Create Rotations based on exisitig Flight.
    * Note: Definition Rotation: an aircraft flies to a series of consecutive..
    * Note: airports and then returns back from the last airport directly to..
    * Note: the initial airport.
    * Goal: We need to detect all flights between the initial airport
    * Note: DIRECT, VIA, TRIA
    *
    */
    mut_buildRotations: (state, payload) => {

        let nestedAircraftsWithFlights;

        /***************************************************************************
        * helper_nestAircraftsWithFlights()
        *
        * Desc: Returns an Array of Objects
        * Desc: Each Object contains an Aircraft with all related Flights
        * Note: Flights are sorted from old to new
        *
        */
        const helper_nestAircraftsWithFlights = () => {

            const nestedAircraftsWithFlights = [];
            let flights = [];

            flights = state.slotmanagement_flights_Filtered;
            // Look up each flight and look at the aircraft which is used.
            // If Aircraft wasn't found in Array[aircraftWithFlights], then push a new Object with Aircraft Code and a Flights Array into it
            // If Aircraft was found in Array[aircraftWithFlights], then add the flight into the Object of this Aircraft
            // This way we get an Array with seperated Aircrafts and all of its flights
            flights.forEach(flight => {

                let foundAircraft = null;

                foundAircraft = nestedAircraftsWithFlights.find(aircraft => aircraft.code === flight.aircraft.code);
                if (foundAircraft) {
                    foundAircraft.children = [...foundAircraft.children, flight];
                } else {
                        nestedAircraftsWithFlights.push({
                            id: flight.aircraft.code,
                            code: flight.aircraft.code,
                            children: [flight]
                        });
                    }
            });

            nestedAircraftsWithFlights.sort((a, b) => {

                // FLYAIR and SUNDAIR
                if (a.code.includes('SUB') === false && b.code.includes('SUB') === false) {
                    if (a.code.startsWith('FlyAir') === true && b.code.startsWith('FlyAir') === true) {
                        return 0;
                    }
                    if (a.code.startsWith('FlyAir') === false && b.code.startsWith('FlyAir') === true) {
                        return -1;
                    }
                    if (a.code.startsWith('FlyAir') === true && b.code.startsWith('FlyAir') === false) {
                        return 1;
                    }
                }
                if (a.code.includes('SUB') === false && b.code.includes('SUB') === false) {
                    if (a.code.startsWith('D-') === true && b.code.startsWith('D-') === true) {
                        return 0;
                    }
                    if (a.code.startsWith('D-') === false && b.code.startsWith('D-') === true) {
                        return -1;
                    }
                    if (a.code.startsWith('D-') === true && b.code.startsWith('D-') === false) {
                        return 1;
                    }
                }

                // SUBs
                if (a.code.includes('SUB') === true && a.code > b.code) {
                    return 1;
                }
                if (b.code.includes('SUB') === true && a.code < b.code) {
                    return -1;
                }

            });
            // Sort Flights from old to new
            nestedAircraftsWithFlights.forEach(flight => {
                flight.children = flight.children.sort((a, b) => {
                    if (dayjs(a.aircraft.dep_sch_time).utc().isAfter(dayjs(b.aircraft.dep_sch_time).utc())) {
                        return 1;
                    }
                    if (dayjs(a.aircraft.dep_sch_time).utc().isBefore(dayjs(b.aircraft.dep_sch_time).utc())) {
                        return -1;
                    }
                });
            });

            return nestedAircraftsWithFlights;

        }; // eo function helper_nestAircraftsWithFlights()

        /***************************************************************************
        * helper_isInTimeRange()
        *
        * Desc: To be a part of a rotation, the following Flight can't depart
        * Desc: more then 7 hours after the previous flight
        * Note:
        *
        */
        const helper_isInTimeRange = (firstLeg, secondLeg) => {

            let isInDayRange = false;
            isInDayRange = dayjs(secondLeg.dep_sch_time).diff(dayjs(firstLeg.dep_sch_time), 'hours') < 14;

            return isInDayRange;
        }; // eo function helper_isInTimeRange

        /***************************************************************************
        * helper_buildRotationObject()
        *
        * Desc: Build Rotation Object based on Rotation Type
        * Note:
        *
        */
        function helper_buildRotationObject(type, firstLeg, secondLeg, thirdLeg, fourthLeg) {

            let rotationObject = {
                    aircraft: null,
                    flightNo: '',
                    gridTemplateColumns: '',
                    route: []
                };
            /*******************************************************************
            * helper_helper_getSlotInfo()
            *
            * Desc: Checks if Slot is needed and mismatching slot
            * Note:
            *
            */
            function helper_helper_getSlotInfo(apt, scheduled, slot) {

                let color = 'black',
                    time = '';

                if (apt.coordinated) {
                    if (Vue.prototype.$isMismatchingSlot(scheduled, slot)) {
                        color = 'red';
                    }
                    if (!slot) {
                        time = 'XXXX';
                    } else {
                        time = Vue.prototype.$dayjsLocalToUTC(slot, 'HHmm');
                    }

                    return `<span style="color:${color}">${time}</span>`;
                } else {

                    return '';
                }
            }; // eo function helper_helper_getSlotInfo()

            rotationObject.aircraft = firstLeg.aircraft.code;

            if (type === 'direct') {
                rotationObject.flightNo = firstLeg.flightNo;
                rotationObject.gridTemplateColumns = '85px 85px';
                rotationObject.route = [
                    // schedule - direct
                    {
                        type: 'schedule',
                        route: `${firstLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(firstLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        type: 'schedule',
                        route: `${Vue.prototype.$dayjsLocalToUTC(firstLeg.arr_sch_time, 'HHmm')}${firstLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - direct
                    {
                        type: 'slot',
                        route: `${firstLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(firstLeg.aptFrom, firstLeg.dep_sch_time, firstLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        type: 'slot',
                        route: `${helper_helper_getSlotInfo(firstLeg.aptTo, firstLeg.arr_sch_time, firstLeg.arr_slt_time)}${firstLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    }
                ];
                rotationObject.slotStatus = [
                    // slot request status - direct
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'firstLeg',
                        direction: 'dep',
                        coordinated: firstLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: firstLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'firstLeg',
                        direction: 'arr',
                        coordinated: firstLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: firstLeg }]
                    }
                ];
                rotationObject.flightModus = firstLeg.mainServiceType;

            } else if (type === 'via') {
                rotationObject.flightNo = `${firstLeg.flightNo}`;
                rotationObject.gridTemplateColumns = '85px 115px 85px';
                rotationObject.route = [
                    // schedule - via
                    {
                        route: `${firstLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(firstLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(firstLeg.arr_sch_time, 'HHmm')}${firstLeg.aptTo.aptCode}${Vue.prototype.$dayjsLocalToUTC(secondLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(secondLeg.arr_sch_time, 'HHmm')}${secondLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - via
                    {
                        route: `${firstLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(firstLeg.aptFrom, firstLeg.dep_sch_time, firstLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(firstLeg.aptTo, firstLeg.arr_sch_time, firstLeg.arr_slt_time)}${firstLeg.aptTo.aptCode}${helper_helper_getSlotInfo(secondLeg.aptFrom, secondLeg.dep_sch_time, secondLeg.dep_slt_time)}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(secondLeg.aptTo, secondLeg.arr_sch_time, secondLeg.arr_slt_time)}${secondLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    }
                ];
                rotationObject.slotStatus = [
                    // slot request status - via
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'firstLeg',
                        direction: 'dep',
                        coordinated: firstLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: firstLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.arrSlotStatus === secondLeg.depSlotStatus ? firstLeg.arrSlotStatus : '***'}`,
                        justifyContent: 'center',
                        leg: 'firstLeg',
                        direction: 'arr',
                        coordinated: firstLeg.aptTo.coordinated,
                        isDifferentStatus: firstLeg.arrSlotStatus !== secondLeg.depSlotStatus,
                        flights: [{ field: 'arrSlotStatus', flight: firstLeg }, { field: 'depSlotStatus', flight: secondLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${secondLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'secondLeg',
                        direction: 'arr',
                        coordinated: secondLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: secondLeg }]
                    }
                ];
                rotationObject.flightModus = `${firstLeg.mainServiceType}`;

            } else if (type === 'direct-direct') {
                rotationObject.flightNo = `${firstLeg.flightNo} / ${secondLeg.flightNo}`;
                rotationObject.gridTemplateColumns = '85px 85px 85px 85px';
                rotationObject.route = [
                    // schedule - direct
                    {
                        route: `${firstLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(firstLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(firstLeg.arr_sch_time, 'HHmm')}${firstLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // schedule - direct
                    {
                        route: `${secondLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(secondLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(secondLeg.arr_sch_time, 'HHmm')}${secondLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - direct
                    {
                        route: `${firstLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(firstLeg.aptFrom, firstLeg.dep_sch_time, firstLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(firstLeg.aptTo, firstLeg.arr_sch_time, firstLeg.arr_slt_time)}${firstLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - direct
                    {
                        route: `${secondLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(secondLeg.aptFrom, secondLeg.dep_sch_time, secondLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(secondLeg.aptTo, secondLeg.arr_sch_time, secondLeg.arr_slt_time)}${secondLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    }
                ];
                rotationObject.slotStatus = [
                    // slot request status - direct
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'firstLeg',
                        direction: 'dep',
                        coordinated: firstLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: firstLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'firstLeg',
                        direction: 'arr',
                        coordinated: firstLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: firstLeg }]
                    },
                    // slot request status - direct
                    {
                        type: 'slotRequestStatus',
                        status: `${secondLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'secondLeg',
                        direction: 'dep',
                        coordinated: secondLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: secondLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${secondLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'secondLeg',
                        direction: 'arr',
                        coordinated: secondLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: secondLeg }]
                    }
                ];
                rotationObject.flightModus = `${firstLeg.mainServiceType}${secondLeg.mainServiceType}`;

            } else if (type === 'direct-via') {
                rotationObject.flightNo = `${firstLeg.flightNo} / ${secondLeg.flightNo}`;
                rotationObject.gridTemplateColumns = '85px 85px 85px 115px 85px';
                rotationObject.route = [
                    // schedule - direct
                    {
                        route: `${firstLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(firstLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(firstLeg.arr_sch_time, 'HHmm')}${firstLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // schedule - via
                    {
                        route: `${secondLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(secondLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(secondLeg.arr_sch_time, 'HHmm')}${secondLeg.aptTo.aptCode}${Vue.prototype.$dayjsLocalToUTC(thirdLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(thirdLeg.arr_sch_time, 'HHmm')}${thirdLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - direct
                    {
                        route: `${firstLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(firstLeg.aptFrom, firstLeg.dep_sch_time, firstLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(firstLeg.aptTo, firstLeg.arr_sch_time, firstLeg.arr_slt_time)}${firstLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - via
                    {
                        route: `${secondLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(secondLeg.aptFrom, secondLeg.dep_sch_time, secondLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(secondLeg.aptTo, secondLeg.arr_sch_time, secondLeg.arr_slt_time)}${secondLeg.aptTo.aptCode}${helper_helper_getSlotInfo(thirdLeg.aptFrom, thirdLeg.dep_sch_time, thirdLeg.dep_slt_time)}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(thirdLeg.aptTo, thirdLeg.arr_sch_time, thirdLeg.arr_slt_time)}${thirdLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    }
                ];
                rotationObject.slotStatus = [
                    // slot request status - direct
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'firstLeg',
                        direction: 'dep',
                        coordinated: firstLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: firstLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'firstLeg',
                        direction: 'arr',
                        coordinated: firstLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: firstLeg }]
                    },
                    // slot request status - via
                    {
                        type: 'slotRequestStatus',
                        status: `${secondLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'secondLeg',
                        direction: 'dep',
                        coordinated: secondLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: secondLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${secondLeg.arrSlotStatus === thirdLeg.depSlotStatus ? secondLeg.arrSlotStatus : '***'}`,
                        justifyContent: 'center',
                        leg: 'secondLeg',
                        direction: 'arr',
                        coordinated: secondLeg.aptTo.coordinated,
                        isDifferentStatus: secondLeg.arrSlotStatus !== thirdLeg.depSlotStatus,
                        flights: [{ field: 'arrSlotStatus', flight: secondLeg }, { field: 'depSlotStatus', flight: thirdLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${thirdLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'thirdLeg',
                        direction: 'arr',
                        coordinated: thirdLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: thirdLeg }]
                    }
                ];

                rotationObject.flightModus = `${firstLeg.mainServiceType}${secondLeg.mainServiceType}`;

            } else if (type === 'via-direct') {
                rotationObject.flightNo = `${firstLeg.flightNo} / ${thirdLeg.flightNo}`;
                rotationObject.gridTemplateColumns = '85px 115px 85px 85px 85px';
                rotationObject.route = [
                    // schedule - via
                    {
                        route: `${firstLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(firstLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(firstLeg.arr_sch_time, 'HHmm')}${firstLeg.aptTo.aptCode}${Vue.prototype.$dayjsLocalToUTC(secondLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(secondLeg.arr_sch_time, 'HHmm')}${secondLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // schedule - direct
                    {
                        route: `${thirdLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(thirdLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(thirdLeg.arr_sch_time, 'HHmm')}${thirdLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - via
                    {
                        route: `${firstLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(firstLeg.aptFrom, firstLeg.dep_sch_time, firstLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(firstLeg.aptTo, firstLeg.arr_sch_time, firstLeg.arr_slt_time)}${firstLeg.aptTo.aptCode}${helper_helper_getSlotInfo(secondLeg.aptFrom, secondLeg.dep_sch_time, secondLeg.dep_slt_time)}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(secondLeg.aptTo, secondLeg.arr_sch_time, secondLeg.arr_slt_time)}${secondLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - direct
                    {
                        route: `${thirdLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(thirdLeg.aptFrom, thirdLeg.dep_sch_time, thirdLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(thirdLeg.aptTo, thirdLeg.arr_sch_time, thirdLeg.arr_slt_time)}${thirdLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    }
                ];
                rotationObject.slotStatus = [
                    // slot request status - via
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'firstLeg',
                        direction: 'dep',
                        coordinated: firstLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: firstLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.arrSlotStatus === secondLeg.depSlotStatus ? firstLeg.arrSlotStatus : '***'}`,
                        justifyContent: 'center',
                        leg: 'firstLeg',
                        direction: 'arr',
                        coordinated: firstLeg.aptTo.coordinated,
                        isDifferentStatus: firstLeg.arrSlotStatus !== secondLeg.depSlotStatus,
                        flights: [{ field: 'arrSlotStatus', flight: firstLeg }, { field: 'depSlotStatus', flight: secondLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${secondLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'secondLeg',
                        direction: 'arr',
                        coordinated: secondLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: secondLeg }]
                    },
                    // slot request status - direct
                    {
                        type: 'slotRequestStatus',
                        status: `${thirdLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'thirdLeg',
                        direction: 'dep',
                        coordinated: thirdLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: thirdLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${thirdLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'thirdLeg',
                        direction: 'arr',
                        coordinated: thirdLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: thirdLeg }]
                    }
                ];
                rotationObject.flightModus = `${firstLeg.mainServiceType}${thirdLeg.mainServiceType}`;

            } else if (type === 'via-via') {
                rotationObject.flightNo = `${firstLeg.flightNo} / ${thirdLeg.flightNo}`;
                rotationObject.gridTemplateColumns = '85px 115px 85px 85px 115px 85px';
                rotationObject.route = [
                    // schedule - via
                    {
                        route: `${firstLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(firstLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(firstLeg.arr_sch_time, 'HHmm')}${firstLeg.aptTo.aptCode}${Vue.prototype.$dayjsLocalToUTC(secondLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(secondLeg.arr_sch_time, 'HHmm')}${secondLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // schedule - via
                    {
                        route: `${thirdLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(thirdLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(thirdLeg.arr_sch_time, 'HHmm')}${thirdLeg.aptTo.aptCode}${Vue.prototype.$dayjsLocalToUTC(fourthLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(fourthLeg.arr_sch_time, 'HHmm')}${fourthLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - via
                    {
                        route: `${firstLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(firstLeg.aptFrom, firstLeg.dep_sch_time, firstLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(firstLeg.aptTo, firstLeg.arr_sch_time, firstLeg.arr_slt_time)}${firstLeg.aptTo.aptCode}${helper_helper_getSlotInfo(secondLeg.aptFrom, secondLeg.dep_sch_time, secondLeg.dep_slt_time)}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(secondLeg.aptTo, secondLeg.arr_sch_time, secondLeg.arr_slt_time)}${secondLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - via
                    {
                        route: `${thirdLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(thirdLeg.aptFrom, thirdLeg.dep_sch_time, thirdLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(thirdLeg.aptTo, thirdLeg.arr_sch_time, thirdLeg.arr_slt_time)}${thirdLeg.aptTo.aptCode}${helper_helper_getSlotInfo(fourthLeg.aptFrom, fourthLeg.dep_sch_time, fourthLeg.dep_slt_time)}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(fourthLeg.aptTo, fourthLeg.arr_sch_time, fourthLeg.arr_slt_time)}${fourthLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    }
                ];
                rotationObject.slotStatus = [
                    // slot request status - via
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'firstLeg',
                        direction: 'dep',
                        coordinated: firstLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: firstLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.arrSlotStatus === secondLeg.depSlotStatus ? firstLeg.arrSlotStatus : '***'}`,
                        justifyContent: 'center',
                        leg: 'firstLeg',
                        direction: 'arr',
                        coordinated: firstLeg.aptTo.coordinated,
                        isDifferentStatus: firstLeg.arrSlotStatus !== secondLeg.depSlotStatus,
                        flights: [{ field: 'arrSlotStatus', flight: firstLeg }, { field: 'depSlotStatus', flight: secondLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${secondLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'secondLeg',
                        direction: 'arr',
                        coordinated: secondLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: secondLeg }]
                    },
                    // slot request status - via
                    {
                        type: 'slotRequestStatus',
                        status: `${thirdLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'thirdLeg',
                        direction: 'dep',
                        coordinated: thirdLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: thirdLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${thirdLeg.arrSlotStatus === fourthLeg.depSlotStatus ? thirdLeg.arrSlotStatus : '***'}`,
                        justifyContent: 'center',
                        leg: 'thirdLeg',
                        direction: 'arr',
                        coordinated: thirdLeg.aptTo.coordinated,
                        isDifferentStatus: thirdLeg.arrSlotStatus !== fourthLeg.depSlotStatus,
                        flights: [{ field: 'arrSlotStatus', flight: thirdLeg }, { field: 'depSlotStatus', flight: fourthLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${fourthLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'fourthLeg',
                        direction: 'arr',
                        coordinated: fourthLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: fourthLeg }]
                    }
                ];
                rotationObject.flightModus = `${firstLeg.mainServiceType}${thirdLeg.mainServiceType}`;
            } else if (type === 'tria') {
                rotationObject.flightNo = `${firstLeg.flightNo} / ${thirdLeg.flightNo}`;
                rotationObject.gridTemplateColumns = '85px 115px 115px 85px';
                rotationObject.route = [
                    // schedule - tria
                    {
                        route: `${firstLeg.aptFrom.aptCode}${Vue.prototype.$dayjsLocalToUTC(firstLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(firstLeg.arr_sch_time, 'HHmm')}${firstLeg.aptTo.aptCode}${Vue.prototype.$dayjsLocalToUTC(secondLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(secondLeg.arr_sch_time, 'HHmm')}${secondLeg.aptTo.aptCode}${Vue.prototype.$dayjsLocalToUTC(thirdLeg.dep_sch_time, 'HHmm')}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${Vue.prototype.$dayjsLocalToUTC(thirdLeg.arr_sch_time, 'HHmm')}${thirdLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    },
                    // slot - tria
                    {
                        route: `${firstLeg.aptFrom.aptCode}${helper_helper_getSlotInfo(firstLeg.aptFrom, firstLeg.dep_sch_time, firstLeg.dep_slt_time)}`,
                        justifyContent: 'unset'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(firstLeg.aptTo, firstLeg.arr_sch_time, firstLeg.arr_slt_time)}${firstLeg.aptTo.aptCode}${helper_helper_getSlotInfo(secondLeg.aptFrom, secondLeg.dep_sch_time, secondLeg.dep_slt_time)}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(secondLeg.aptTo, secondLeg.arr_sch_time, secondLeg.arr_slt_time)}${secondLeg.aptTo.aptCode}${helper_helper_getSlotInfo(thirdLeg.aptFrom, thirdLeg.dep_sch_time, thirdLeg.dep_slt_time)}`,
                        justifyContent: 'center'
                    },
                    {
                        route: `${helper_helper_getSlotInfo(thirdLeg.aptTo, thirdLeg.arr_sch_time, thirdLeg.arr_slt_time)}${thirdLeg.aptTo.aptCode}`,
                        justifyContent: 'end'
                    }
                ];
                rotationObject.slotStatus = [
                    // slot request status - tria
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.depSlotStatus}`,
                        justifyContent: 'unset',
                        leg: 'firstLeg',
                        direction: 'dep',
                        coordinated: firstLeg.aptFrom.coordinated,
                        flights: [{ field: 'depSlotStatus', flight: firstLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${firstLeg.arrSlotStatus === secondLeg.depSlotStatus ? firstLeg.arrSlotStatus : '***'}`,
                        justifyContent: 'center',
                        leg: 'firstLeg',
                        direction: 'arr',
                        coordinated: firstLeg.aptTo.coordinated,
                        isDifferentStatus: firstLeg.arrSlotStatus !== secondLeg.depSlotStatus,
                        flights: [{ field: 'arrSlotStatus', flight: firstLeg }, { field: 'depSlotStatus', flight: secondLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${secondLeg.arrSlotStatus === thirdLeg.depSlotStatus ? secondLeg.arrSlotStatus : '***'}`,
                        justifyContent: 'center',
                        leg: 'secondLeg',
                        direction: 'arr',
                        coordinated: secondLeg.aptTo.coordinated,
                        isDifferentStatus: secondLeg.arrSlotStatus !== thirdLeg.depSlotStatus,
                        flights: [{ field: 'arrSlotStatus', flight: secondLeg }, { field: 'depSlotStatus', flight: thirdLeg }]
                    },
                    {
                        type: 'slotRequestStatus',
                        status: `${thirdLeg.arrSlotStatus}`,
                        justifyContent: 'end',
                        leg: 'thirdLeg',
                        direction: 'arr',
                        coordinated: thirdLeg.aptTo.coordinated,
                        flights: [{ field: 'arrSlotStatus', flight: thirdLeg }]
                    }
                ];
                rotationObject.flightModus = `${firstLeg.mainServiceType}${thirdLeg.mainServiceType}`;
            } else {
                rotationObject.flightNo = '';
                rotationObject.gridTemplateColumns = '';
                rotationObject.route = [];
                rotationObject.slotStatus = [];
            }

            return rotationObject;
        }; // eo function helper_buildRotationObject

        /***************************************************************************
        * helper_buildAirportsWithSlots()
        *
        * Desc: Build Slot Request Object based on Rotation
        * Note:
        *   //           DEP DEP ARR ARR
            // flights = BER-BEY BEY-BER
            // airportsWithSlots =
            //    [
            //     {
            //         airport: BER,
            //         slots: [DEP, ARR]
            //     },
                        //     {
            //         airport: BEY,
            //         slots: [DEP, ARR]
            //     }
            // ]
        *
        */
        function helper_buildAirportsWithSlots(flights, type) {

            const me = this;
            let airportsWithSlots = [],
                foundAirportWithSlot = null;

            function helper_getViaAirport (direction, index, defaultViaAirport) {

                let viaAirport = null;
                if (type === 'via') {
                    if (direction === 'DEPARTURE') {
                        if (index === 0) {
                            viaAirport = flights[1].aptTo.aptCode;
                        }
                    } else if (direction === 'ARRIVAL') {
                        if (index === 1) {
                            viaAirport = flights[0].aptFrom.aptCode;
                        }
                    }
                } else if (type === 'via' || type === 'via-direct') {
                    if (direction === 'DEPARTURE') {
                        if (index === 0) {
                            viaAirport = flights[1].aptTo.aptCode;
                        }
                        if (index === 1) {
                            viaAirport = flights[2].aptTo.aptCode;
                        }
                    } else if (direction === 'ARRIVAL') {
                        if (index === 1) {
                            viaAirport = flights[0].aptFrom.aptCode;
                        }
                        // if (index === 2) {
                        //     viaAirport = flights[1].aptFrom.aptCode;
                        // }
                    }
                } else if (type === 'direct-via') {
                    if (direction === 'DEPARTURE') {
                        if (index === 1) {
                            viaAirport = flights[2].aptTo.aptCode;
                        }
                    } else if (direction === 'ARRIVAL') {
                        if (index === 2) {
                            viaAirport = flights[1].aptFrom.aptCode;
                        }
                    }
                } else if (type === 'via-via') {
                    if (direction === 'DEPARTURE') {
                        if (index === 0) {
                            viaAirport = flights[1].aptTo.aptCode;
                        } else if (index === 2) {
                            viaAirport = flights[3].aptFrom.aptCode;
                        }
                    } else if (direction === 'ARRIVAL') {
                        if (index === 1) {
                            viaAirport = flights[0].aptTo.aptCode;
                        } else if (index === 3) {
                            viaAirport = flights[2].aptFrom.aptCode;
                        }

                    }
                } else if (type === 'tria') {
                    if (direction === 'DEPARTURE') {
                        if (index === 0) {
                            viaAirport = flights[1].aptTo.aptCode;
                        } else if (index === 1) {
                            viaAirport = flights[2].aptTo.aptCode;
                        }
                    } else if (direction === 'ARRIVAL') {
                        if (index === 1) {
                            viaAirport = flights[0].aptFrom.aptCode;
                        } else if (index === 2) {
                            viaAirport = flights[1].aptFrom.aptCode;
                        }
                    }
                }

                return viaAirport || '';

            }

            flights.forEach((flight, index) => {

                foundAirportWithSlot = airportsWithSlots.find(airportWithSlots => airportWithSlots.airport.aptCode === flight.aptFrom.aptCode);
                if (foundAirportWithSlot) {
                    foundAirportWithSlot.slots.push({
                        idFlight: flight.idFlight,
                        internationalFormat: flight.aptFrom.details.idCountry !== 70,
                        date: dayjs(flight.dep_sch_time).utc().format(),
                        slotTime: flight.dep_slt_time ? dayjs(flight.dep_slt_time).utc().format('HHmm') : null,
                        scheduledTime: dayjs(flight.dep_sch_time).utc().format('HHmm'),
                        airport: flight.aptTo.aptCode,
                        viaAirport: helper_getViaAirport('DEPARTURE', index, flight.aptTo.aptCode),
                        direction: 'DEPARTURE',
                        aircraft: flight.aircraft,
                        flightNo: flight.flightNo,
                        flightModus: flight.mainServiceType,
                        flight: flight
                    });
                } else {
                    airportsWithSlots.push({
                        airport: flight.aptFrom,
                        slots: [
                            {
                                idFlight: flight.idFlight,
                                idGroup: null,
                                internationalFormat: flight.aptFrom.details.idCountry !== 70,
                                date: dayjs(flight.dep_sch_time).utc().format(),
                                slotTime: flight.dep_slt_time ? dayjs(flight.dep_slt_time).utc().format('HHmm') : null,
                                scheduledTime: dayjs(flight.dep_sch_time).utc().format('HHmm'),
                                airport: flight.aptTo.aptCode,
                                viaAirport: helper_getViaAirport('DEPARTURE', index, flight.aptTo.aptCode),
                                direction: 'DEPARTURE',
                                aircraft: flight.aircraft,
                                flightNo: flight.flightNo,
                                flightModus: flight.mainServiceType,
                                flight: flight
                            }
                        ]
                    });
                }
                foundAirportWithSlot = airportsWithSlots.find(airportWithSlots => airportWithSlots.airport.aptCode === flight.aptTo.aptCode);
                if (foundAirportWithSlot) {
                    foundAirportWithSlot.slots.push({
                        idFlight: flight.idFlight,
                        internationalFormat: flight.aptTo.details.idCountry !== 70,
                        date: dayjs(flight.arr_sch_time).utc().format(),
                        slotTime: flight.arr_slt_time ? dayjs(flight.arr_slt_time).utc().format('HHmm') : null,
                        scheduledTime: dayjs(flight.arr_sch_time).utc().format('HHmm'),
                        airport: flight.aptFrom.aptCode,
                        viaAirport: helper_getViaAirport('ARRIVAL', index, flight.aptFrom.aptCode),
                        direction: 'ARRIVAL',
                        aircraft: flight.aircraft,
                        flightNo: flight.flightNo,
                        flightModus: flight.mainServiceType,
                        flight: flight
                    });
                } else {
                    airportsWithSlots.push({
                        airport: flight.aptTo,
                        slots: [
                            {
                                idFlight: flight.idFlight,
                                internationalFormat: flight.aptTo.details.idCountry !== 70,
                                date: dayjs(flight.arr_sch_time).utc().format(),
                                slotTime: flight.arr_slt_time ? dayjs(flight.arr_slt_time).utc().format('HHmm') : null,
                                scheduledTime: dayjs(flight.arr_sch_time).utc().format('HHmm'),
                                airport: flight.aptFrom.aptCode,
                                viaAirport: helper_getViaAirport('ARRIVAL', index, flight.aptFrom.aptCode),
                                direction: 'ARRIVAL',
                                aircraft: flight.aircraft,
                                flightNo: flight.flightNo,
                                flightModus: flight.mainServiceType,
                                flight: flight
                            }
                        ]
                    });
                }
            });

            return airportsWithSlots;

        }; // eo function helper_buildAirportsWithSlots

        /***************************************************************************
        * helper_recursiveLookForNextFlights()
        *
        * Desc: Looks from the current "firstLeg" through next flights until
        * Desc: a fitting "secondLeg" is found or no flights left
        * Note:
        *
        */
        const helper_recursiveLookForNextFlights = (firstLeg, allFlightsOnAircraft, nextLeg) => {

            let foundFlight = null;

            if (!allFlightsOnAircraft[nextLeg + 1]) {
                return;
            }

            if (firstLeg.aptFrom.aptCode === allFlightsOnAircraft[nextLeg + 1].aptTo.aptCode &&
                helper_isInTimeRange(firstLeg, allFlightsOnAircraft[nextLeg + 1])) {

                foundFlight = nextLeg + 1;
                return foundFlight; // index of found flight
            } else {

                return helper_recursiveLookForNextFlights(firstLeg, allFlightsOnAircraft, nextLeg + 1);
            }
        }; // eo function helper_recursiveLookForNextFlights


        /***************************************************************************
        * createRotationForEachFlight()
        *
        * Desc: Returns an Array of Objects
        * Desc: Each Object contains an Aircraft with all related Rotations
        * Note: It's possible that a Rotation contains 1 - 4 flights
        * Note: Types: 'direct', 'direct-direct', 'direct-via', 'via-direct', 'via-via'
        *
        */
        const createRotationForEachFlight = (aircraftsWithFlights) => {

            const rotations = [];

            aircraftsWithFlights.forEach(aircraft => {

                let firstLeg = 0,
                    alreadyGroupedFlights = [];

                aircraft.children.sort((a, b) => {
                    if (a.dep_sch_time > b.dep_sch_time) {
                        return 1;
                    } else {
                        return -1;
                    }
                });

                aircraft.children.forEach((flight, index) => {
                    let rotation = {},
                        secondLeg = firstLeg + 1,
                        thirdLeg = secondLeg + 1,
                        fourthLeg = thirdLeg + 1;

                    if (firstLeg >= aircraft.children.length ||
                        alreadyGroupedFlights.includes(firstLeg)) {
                        return;
                    }
                    if (aircraft.children[firstLeg].flightType === 'D') {
                        rotation = {
                            id: `rotation-${aircraft.children[firstLeg].idFlight}`,
                            date: aircraft.children[firstLeg].dep_sch_time,
                            flightNo: [aircraft.children[firstLeg].flightNo],
                            type: 'direct',
                            isRotation: false,
                            rotationObject: helper_buildRotationObject('direct', aircraft.children[firstLeg]),
                            wasEdited: aircraft.children[firstLeg].wasEdited,
                            slotRequestsRotation: helper_buildAirportsWithSlots([aircraft.children[firstLeg]], 'direct'),
                            children: [
                                {
                                    id: aircraft.children[firstLeg].idFlight,
                                    type: 'firstLeg',
                                    name: 'AB',
                                    leg: aircraft.children[firstLeg],
                                    layer: 3,
                                    wasEdited: aircraft.children[firstLeg].wasEdited,
                                    slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[firstLeg]], 'direct')
                                }
                            ],
                            layer: 2
                        };

                        if (aircraft.children[secondLeg] && aircraft.children[secondLeg].flightType === 'D') {
                            if (aircraft.children[firstLeg].aptFrom.aptCode === aircraft.children[secondLeg].aptTo.aptCode && helper_isInTimeRange(aircraft.children[firstLeg], aircraft.children[secondLeg])) {
                                rotation.id = `rotation-${aircraft.children[firstLeg].idFlight}${aircraft.children[secondLeg].idFlight}`;
                                rotation.type = 'direct-direct';
                                rotation.isRotation = true;
                                rotation.rotationObject = helper_buildRotationObject('direct-direct', aircraft.children[firstLeg], aircraft.children[secondLeg]);
                                rotation.flightNo.push(
                                    aircraft.children[secondLeg].flightNo
                                );
                                rotation.wasEdited = aircraft.children[secondLeg].wasEdited;
                                rotation.slotRequestsRotation = helper_buildAirportsWithSlots([aircraft.children[firstLeg], aircraft.children[secondLeg]], 'direct-direct');
                                rotation.children.push(
                                    {
                                        id: aircraft.children[secondLeg].idFlight,
                                        type: 'secondLeg',
                                        name: 'AB',
                                        leg: aircraft.children[secondLeg],
                                        layer: 3,
                                        wasEdited: aircraft.children[secondLeg].wasEdited,
                                        slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[secondLeg]], 'direct')
                                    }
                                );
                                firstLeg += 1;
                            } else if (aircraft.children[firstLeg].aptTo.aptCode === aircraft.children[secondLeg].aptFrom.aptCode && helper_isInTimeRange(aircraft.children[firstLeg], aircraft.children[secondLeg])) {
                                rotation.id = `rotation-${aircraft.children[firstLeg].idFlight}${aircraft.children[secondLeg].idFlight}`;
                                rotation.type = 'direct-direct';
                                rotation.isRotation = true;
                                rotation.rotationObject = helper_buildRotationObject('direct-direct', aircraft.children[firstLeg], aircraft.children[secondLeg]);
                                rotation.flightNo.push(
                                    aircraft.children[secondLeg].flightNo
                                );
                                rotation.wasEdited = aircraft.children[secondLeg].wasEdited;
                                rotation.slotRequestsRotation = helper_buildAirportsWithSlots([aircraft.children[firstLeg], aircraft.children[secondLeg]], 'direct-direct');
                                rotation.children.push(
                                    {
                                        id: aircraft.children[secondLeg].idFlight,
                                        type: 'secondLeg',
                                        name: 'AB',
                                        leg: aircraft.children[secondLeg],
                                        layer: 3,
                                        wasEdited: aircraft.children[secondLeg].wasEdited,
                                        slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[secondLeg]], 'direct')
                                    }
                                );
                                firstLeg += 1;
                            }
                            // else if (aircraft.children[firstLeg].collisionCheck.length === 0) {
                            //     // recursive TODO: VIA is missing
                            //     let nextFlight = helper_recursiveLookForNextFlights(aircraft.children[firstLeg], aircraft.children, firstLeg);
                            //     if (nextFlight) {
                            //         rotation.id = `rotation-${aircraft.children[firstLeg].idFlight}${aircraft.children[nextFlight].idFlight}`;
                            //         rotation.type = 'direct-direct';
                            //         rotation.isRotation = true;
                            //         rotation.rotationObject = helper_buildRotationObject('direct-direct', aircraft.children[firstLeg], aircraft.children[nextFlight]);
                            //         rotation.flightNo.push(
                            //             aircraft.children[nextFlight].flightNo
                            //         );
                            //         rotation.wasEdited = aircraft.children[nextFlight].wasEdited;
                            //         rotation.slotRequestsRotation = helper_buildAirportsWithSlots([aircraft.children[firstLeg], aircraft.children[nextFlight]], 'direct-direct');
                            //         rotation.children.push(
                            //             {
                            //                 id: aircraft.children[nextFlight].idFlight,
                            //                 type: 'secondLeg',
                            //                 name: 'AB',
                            //                 leg: aircraft.children[nextFlight],
                            //                 layer: 3,
                            //                 wasEdited: aircraft.children[nextFlight].wasEdited,
                            //                 slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[nextFlight]], 'direct')
                            //             }
                            //         );
                            //         alreadyGroupedFlights.push(nextFlight);
                            //     }
                            // }
                        } else if (aircraft.children[secondLeg] && aircraft.children[secondLeg].flightType === 'V') {
                            if (aircraft.children[firstLeg].aptFrom.aptCode === aircraft.children[thirdLeg].aptTo.aptCode && helper_isInTimeRange(aircraft.children[firstLeg], aircraft.children[secondLeg])) {
                                rotation.id = `rotation-${aircraft.children[firstLeg].idFlight}${aircraft.children[secondLeg].idFlight}${aircraft.children[thirdLeg].idFlight}`;
                                rotation.type = 'direct-via';
                                rotation.isRotation = true;
                                rotation.rotationObject = helper_buildRotationObject('direct-via', aircraft.children[firstLeg], aircraft.children[secondLeg], aircraft.children[thirdLeg]);
                                rotation.flightNo.push(
                                    aircraft.children[secondLeg].flightNo,
                                    aircraft.children[thirdLeg].flightNo
                                );
                                rotation.wasEdited = aircraft.children[secondLeg].wasEdited || aircraft.children[thirdLeg].wasEdited;
                                rotation.slotRequestsRotation = helper_buildAirportsWithSlots([aircraft.children[firstLeg], aircraft.children[secondLeg], aircraft.children[thirdLeg]], 'direct-via');
                                rotation.children.push(
                                    {
                                        id: aircraft.children[secondLeg].idFlight,
                                        type: 'secondLeg',
                                        name: 'AB',
                                        leg: aircraft.children[secondLeg],
                                        layer: 3,
                                        wasEdited: aircraft.children[secondLeg].wasEdited,
                                        slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[secondLeg]], 'direct')
                                    },
                                    {
                                        id: aircraft.children[thirdLeg].idFlight,
                                        type: 'secondLeg',
                                        name: 'BC',
                                        leg: aircraft.children[thirdLeg],
                                        layer: 3,
                                        wasEdited: aircraft.children[thirdLeg].wasEdited,
                                        slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[thirdLeg]], 'direct')
                                    }
                                );
                                firstLeg += 2;
                            }
                        }
                        rotations.push(rotation);
                        firstLeg += 1;
                    } else if (aircraft.children[firstLeg].flightType === 'V') {
                        rotation = {
                            id: `rotation-${aircraft.children[firstLeg].idFlight}${aircraft.children[secondLeg].idFlight}`,
                            date: aircraft.children[firstLeg].dep_sch_time,
                            flightNo: [aircraft.children[firstLeg].flightNo],
                            type: 'via',
                            isRotation: false,
                            rotationObject: helper_buildRotationObject('via', aircraft.children[firstLeg], aircraft.children[secondLeg]),
                            wasEdited: aircraft.children[firstLeg].wasEdited || aircraft.children[secondLeg].wasEdited,
                            slotRequestsRotation: helper_buildAirportsWithSlots([aircraft.children[firstLeg], aircraft.children[secondLeg]], 'via'),
                            children: [
                                {
                                    id: aircraft.children[firstLeg].idFlight,
                                    type: 'firstLeg',
                                    name: 'AB',
                                    leg: aircraft.children[firstLeg], // build via flight object
                                    layer: 3,
                                    wasEdited: aircraft.children[firstLeg].wasEdited,
                                    slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[firstLeg]], 'direct')
                                },
                                {
                                    id: aircraft.children[secondLeg].idFlight,
                                    type: 'firstLeg',
                                    name: 'BC',
                                    leg: aircraft.children[secondLeg],
                                    layer: 3,
                                    wasEdited: aircraft.children[secondLeg].wasEdited,
                                    slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[secondLeg]], 'direct')
                                }
                            ],
                            layer: 2
                        };
                        if (aircraft.children[thirdLeg] && aircraft.children[thirdLeg].flightType === 'D') {
                            if (aircraft.children[firstLeg].aptFrom.aptCode === aircraft.children[thirdLeg].aptTo.aptCode && helper_isInTimeRange(aircraft.children[firstLeg], aircraft.children[thirdLeg])) {
                                rotation.id = `rotation-${aircraft.children[firstLeg].idFlight}${aircraft.children[secondLeg].idFlight}${aircraft.children[thirdLeg].idFlight}`;
                                rotation.type = 'via-direct';
                                rotation.isRotation = true;
                                rotation.rotationObject = helper_buildRotationObject('via-direct', aircraft.children[firstLeg], aircraft.children[secondLeg], aircraft.children[thirdLeg]);
                                rotation.flightNo.push(
                                    aircraft.children[thirdLeg].flightNo
                                );
                                rotation.wasEdited = aircraft.children[thirdLeg].wasEdited;
                                rotation.slotRequestsRotation = helper_buildAirportsWithSlots([aircraft.children[firstLeg], aircraft.children[secondLeg], aircraft.children[thirdLeg]], 'via-direct');
                                rotation.children.push(
                                    {
                                        id: aircraft.children[thirdLeg].idFlight,
                                        type: 'secondLeg',
                                        name: 'AB',
                                        leg: aircraft.children[thirdLeg],
                                        layer: 3,
                                        wasEdited: aircraft.children[thirdLeg].wasEdited,
                                        slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[thirdLeg]], 'direct')
                                    }
                                );
                                firstLeg += 1;
                            }
                        } else if (aircraft.children[thirdLeg] && aircraft.children[thirdLeg].flightType === 'V') {
                            if (aircraft.children[firstLeg].aptFrom.aptCode === aircraft.children[fourthLeg].aptTo.aptCode && helper_isInTimeRange(aircraft.children[firstLeg], aircraft.children[thirdLeg])) {
                                rotation.id = `rotation-${aircraft.children[firstLeg].idFlight}${aircraft.children[secondLeg].idFlight}${aircraft.children[thirdLeg].idFlight}${aircraft.children[fourthLeg].idFlight}`;
                                rotation.type = 'via-via';
                                rotation.isRotation = true;
                                rotation.rotationObject = helper_buildRotationObject('via-via', aircraft.children[firstLeg], aircraft.children[secondLeg], aircraft.children[thirdLeg], aircraft.children[fourthLeg]);
                                rotation.flightNo.push(
                                    aircraft.children[thirdLeg].flightNo,
                                    aircraft.children[fourthLeg].flightNo
                                );
                                rotation.wasEdited = aircraft.children[thirdLeg].wasEdited || aircraft.children[fourthLeg].wasEdited;
                                rotation.slotRequestsRotation = helper_buildAirportsWithSlots([aircraft.children[firstLeg], aircraft.children[secondLeg], aircraft.children[thirdLeg], aircraft.children[fourthLeg]], 'via-via');
                                rotation.children.push(
                                    {
                                        id: aircraft.children[thirdLeg].idFlight,
                                        type: 'secondLeg',
                                        name: 'AB',
                                        leg: aircraft.children[thirdLeg],
                                        layer: 3,
                                        wasEdited: aircraft.children[thirdLeg].wasEdited,
                                        slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[thirdLeg]], 'direct')
                                    },
                                    {
                                        id: aircraft.children[fourthLeg].idFlight,
                                        type: 'secondLeg',
                                        name: 'BC',
                                        leg: aircraft.children[fourthLeg],
                                        layer: 3,
                                        wasEdited: aircraft.children[fourthLeg].wasEdited,
                                        slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[fourthLeg]], 'direct')
                                    }
                                );
                                firstLeg += 2;
                            }
                        }
                        rotations.push(rotation);
                        firstLeg += 2;
                    } else if (aircraft.children[firstLeg].flightType === 'T') {
                        rotation = {
                            id: `rotation-${aircraft.children[firstLeg].idFlight}${aircraft.children[secondLeg].idFlight}`,
                            date: aircraft.children[firstLeg].dep_sch_time,
                            flightNo: [aircraft.children[firstLeg].flightNo, aircraft.children[thirdLeg].flightNo],
                            type: 'tria',
                            isRotation: false,
                            rotationObject: helper_buildRotationObject('tria', aircraft.children[firstLeg], aircraft.children[secondLeg], aircraft.children[thirdLeg]),
                            wasEdited: aircraft.children[firstLeg].wasEdited || aircraft.children[secondLeg].wasEdited,
                            slotRequestsRotation: helper_buildAirportsWithSlots([aircraft.children[firstLeg], aircraft.children[secondLeg], aircraft.children[thirdLeg]], 'tria'),
                            children: [
                                {
                                    id: aircraft.children[firstLeg].idFlight,
                                    type: 'firstLeg',
                                    name: 'AB',
                                    leg: aircraft.children[firstLeg],
                                    layer: 3,
                                    wasEdited: aircraft.children[firstLeg].wasEdited,
                                    slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[firstLeg]], 'direct')
                                },
                                {
                                    id: aircraft.children[secondLeg].idFlight,
                                    type: 'firstLeg',
                                    name: 'BC',
                                    leg: aircraft.children[secondLeg],
                                    layer: 3,
                                    wasEdited: aircraft.children[secondLeg].wasEdited,
                                    slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[secondLeg]], 'direct')
                                },
                                {
                                    id: aircraft.children[thirdLeg].idFlight,
                                    type: 'firstLeg',
                                    name: 'CA',
                                    leg: aircraft.children[thirdLeg],
                                    layer: 3,
                                    wasEdited: aircraft.children[thirdLeg].wasEdited,
                                    slotRequestLeg: helper_buildAirportsWithSlots([aircraft.children[thirdLeg]], 'direct')
                                }
                            ],
                            layer: 2
                        };
                        rotations.push(rotation);
                        firstLeg += 3;
                    }
                });
            });

            return rotations;
        }; // eo function createRotationForEachFlight()

        /***************************************************************************
        * createRotationChains()
        *
        * Desc: Chains all rotations over given date range together
        * Note: A chain is found when:
        * Note: Get Start Date and "Start" Flight Number -> Add 7 days -> Look for equal flight Numbers
        *
        */
        const createRotationChains = (rotationForEachFlight) => {

            const rotationChains = [];

            rotationForEachFlight.sort((a, b) => {
                if (a.date > b.date) {
                    return 1;
                } else {
                    return -1;
                }
            });

            rotationForEachFlight.forEach((rotation) => {

                let foundRotation = null;

                /***************************************************************************
                * checkForEqualFlightNo()
                *
                * Desc: First Check to group Rotations/Legs into a Chain
                * Desc: Looks for equal Fligt Numbers in Legs / Rotation Layer
                * Note: Rotations could include only partly...
                * Note: matching Flight Numbers over a chain period
                * Example: 1. Rotation in Chain SR1234 - SR1235
                * Example: 2. Rotation in Chain SR123F - SR1235
                * Note: Both Flights should still be shown as ONE Chain
                *
                */
                function helper_checkForEqualFlightNo (chainFlightNos, rotationFlightNos) {

                    let flightNumberFound = false;

                    chainFlightNos.forEach(chainFlightNo => {
                        if (rotationFlightNos.find(rotationFlightNo => rotationFlightNo === chainFlightNo)) {
                            flightNumberFound = true;
                        }

                    });

                    return flightNumberFound;
                }; // eoF helper_checkForEqualFlightNo

                /***************************************************************************
                * isSameDay()
                *
                * Desc: Second Check to group Rotations/Legs into a Chain
                * Desc: Looks for the same "weekday"
                * Note:
                *
                */
                function helper_isSameDay (chainDate, rotationDate) {

                    let isSameDay = false;

                    if (dayjs(rotationDate).startOf('day').diff(dayjs(chainDate).startOf('day'), 'days') % 7 === 0) {
                        isSameDay = true;
                    }

                    return isSameDay;
                }; // eoF helper_isSameDay

                /***************************************************************************
                 * helper_groupSlotRequestStatus()
                 *
                 * Desc: We are grouping slot status for each leg of a rotation
                 * Desc: To group slot status we need to check for:
                 * Desc: 1. Same Leg (firstLeg, secondLeg) 2. Same Direction (dep, arr)
                 * Desc: To show that we have different slot request status within a chain
                 * Desc: we are adding a flag to the slot request status object and put the value '***'
                 * Note:
                 *
                 */
                function helper_groupSlotRequestStatus(chainSlotRequestStatus, rotationSlotRequestStatus) {
                    chainSlotRequestStatus.forEach(csrs => {                    // csrs = chainSlotRequestStatus
                        rotationSlotRequestStatus.forEach(rsrs => {             // rsrs = rotationSlotRequestStatus
                            if (csrs.leg === rsrs.leg && csrs.direction === rsrs.direction) {
                                csrs.isDifferentStatus = csrs.isDifferentStatus ? csrs.isDifferentStatus : rsrs.status !== csrs.status; // once true, stay true
                                csrs.status = csrs.isDifferentStatus ? '***' : csrs.status;
                                csrs.flights = csrs.flights.concat(rsrs.flights);
                            }
                        });
                    });
                    return chainSlotRequestStatus;

                }; // eoF helper_groupSlotRequestStatus

                foundRotation = rotationChains.find(chain => helper_isSameDay(chain.date, rotation.date) && helper_checkForEqualFlightNo(chain.flightNo, rotation.flightNo));

                if (foundRotation) {

                    foundRotation.lastDate = rotation.date;
                    foundRotation.children.push(rotation);
                    foundRotation.leaf.push(rotation);
                    foundRotation.wasEdited = foundRotation.wasEdited ? foundRotation.wasEdited : rotation.wasEdited; // once true, stay true
                    foundRotation.slotRequestsChain.push(rotation.slotRequestsRotation);
                    foundRotation.rotationObject.slotStatus = helper_groupSlotRequestStatus(foundRotation.rotationObject.slotStatus, rotation.rotationObject.slotStatus);

                } else {

                    rotationChains.push({
                        id: 'root-' + rotation.id,
                        flightNo: rotation.flightNo,
                        date: rotation.date,
                        lastDate: null,
                        type: rotation.type,
                        isRotation: rotation.isRotation,
                        children: [rotation],
                        leaf: [rotation],
                        layer: 1,
                        rotationObject: JSON.parse(JSON.stringify(rotation.rotationObject)), // deep copy
                        wasEdited: rotation.wasEdited,
                        slotRequestsChain: [rotation.slotRequestsRotation]
                    });
                }
            });

            return rotationChains;
        };

        nestedAircraftsWithFlights = helper_nestAircraftsWithFlights();
        state.slotmanagement_flightsTable_rotations = createRotationForEachFlight(nestedAircraftsWithFlights);
        state.slotmanagement_flightsTable_rotations_chain = createRotationChains(state.slotmanagement_flightsTable_rotations);

    }, // eo function mut_buildRotations()

    /***************************************************************************
    * mut_createWarnings()
    *
    * Desc: Create Warnings for every layer
    * Note: 1. Layer Flight Chain - Slot Warning | Interrupted Chain | Different Schedule
    * Note: 2. Layer Rotation - Slot Warning | Different Schedule
    * Note: 3. Layer Leg - Slot Warning | Different Schedule
    * Note: Every Layer and included flight is getting compared to the first shown flight in 1. Layer
    * TODO: CLEAN UP!!!
    */
    mut_createWarnings: (state, payload) => {


        let flightChains = state.slotmanagement_flightsTable_rotations_chain_Filtered;

        // >>> LAYER 1 ENTRANCE (CHAIN) ----------------------------------------
        flightChains.forEach((chain, chainIndex) => {

            let parentRotation = null,
                parentFlight = null, // 1. Layer, first flight
                warningsFirstLayer = [],
                warningsSecondLayer = [],
                missingDays = [];

            parentRotation = chain.children.find(rotation => rotation.date === chain.date);
            parentFlight = parentRotation.children[0].children;

            // >>> LAYER 2 ENTRANCE (ROTATIONS) --------------------------------
            chain.children.forEach((rotation, index) => {

                let warningsThirdLayer = [],
                    tmp_warningsSecondLayer = [],
                    dayDifferenceBetweenFollowingLeg = 0;

                // >>> LAYER 3 ENTRANCE (FLIGHTS) ------------------------------
                rotation.children.forEach((flight, index) => {

                    let tmp_warningsThirdLayer = [];

                    // >>> 'LAYER 3: Departure Slot Warning' -------------------
                    if (flight.leg.aptFrom.coordinated && Vue.prototype.$isMismatchingSlot(flight.leg.dep_sch_time, flight.leg.dep_slt_time)) {
                        tmp_warningsThirdLayer.push({
                            type: 'depSlot',
                            text: 'Departure Slot Issue',
                            icon: 'mdi-timer-alert'
                        });
                    }

                    // >>> 'LAYER 3: Arrival Slot Warning' ---------------------
                    if (flight.leg.aptTo.coordinated && Vue.prototype.$isMismatchingSlot(flight.leg.arr_sch_time, flight.leg.arr_slt_time)) {
                        tmp_warningsThirdLayer.push({
                            type: 'arrSlot',
                            text: 'Arrival Slot Issue',
                            icon: 'mdi-timer-alert'
                        });
                    }

                    if (flight.leg.deleted) {
                        tmp_warningsThirdLayer.push({
                            type: 'deleted',
                            text: 'Flight Deleted',
                            icon: 'mdi-trash-can'
                        });
                    }

                    // >>> 'LAYER 3: Slot Warning' ---------------------
                    if (flight.leg.collisionCheck.length > 0) {
                        flight.leg.collisionCheck.forEach(collision => {
                            if (collision.type === 'DEPARTURE AIRPORT') {
                                tmp_warningsThirdLayer.push({
                                    type: 'collisionCheck',
                                    text: "Departure Airport doesn't fit to previous arrival Airport",
                                    icon: 'mdi-airplane-takeoff'
                                });
                            }
                            if (collision.type === 'DESTINATION AIRPORT') {
                                tmp_warningsThirdLayer.push({
                                    type: 'collisionCheck',
                                    text: "Arrival Airport doesn't fit to next departure Airport",
                                    icon: 'mdi-airplane-landing'
                                });
                            }
                            if (collision.type === 'COLLISION') {
                                tmp_warningsThirdLayer.push({
                                    type: 'collisionCheck',
                                    text: 'Collision with other Flight',
                                    icon: 'mdi-unfold-less-vertical'
                                });
                            }
                            if (collision.type === 'FLIGHTNO') {
                                tmp_warningsThirdLayer.push({
                                    type: 'collisionCheck',
                                    text: 'Flight Number already exists on that day',
                                    icon: 'mdi-numeric'
                                });
                            }
                        });
                    }

                    flight.warnings = tmp_warningsThirdLayer;
                    tmp_warningsThirdLayer.forEach(t => {
                        warningsThirdLayer.push(t);
                    });

                });
                // <<< LAYER 3 EXIT (FLIGHTS) ----------------------------------

                // >>> 'LAYER 1: Interrupted Chain Warning' --------------------
                if (chain.children[index + 1]) {
                    dayDifferenceBetweenFollowingLeg = dayjs(chain.children[index + 1].date).startOf('day').diff(dayjs(chain.children[index].date).startOf('day'), 'days');
                }

                if (dayDifferenceBetweenFollowingLeg !== 0 && dayDifferenceBetweenFollowingLeg !== 7) {
                    // Add missing Flight
                    missingDays.push({
                        index: index + 1,
                        data: {
                            type: 'missingFlight',
                            date: dayjs(chain.children[index].date).add(7, 'days').format('YYYY-MM-DDTHHmm:ss[Z]'),
                            children: [],
                            warnings: [{
                                type: 'interruptedChain',
                                text: 'Missing Flight',
                                icon: 'mdi-list-status'
                            }]
                        }
                    });
                }

                // >>> 'LAYER 2: Different Schedule' ---------------------------
                if (rotation.type !== 'missingFlight' && parentRotation.children.length !== rotation.children.length) {
                    tmp_warningsSecondLayer.push({
                        type: 'differentSchedule',
                        text: 'Different Schedule',
                        icon: 'mdi-airplane-clock'
                    });
                }

                // >>> 'LAYER 2: Departure Slot Warning' ---------------------------
                if (rotation.type !== 'missingFlight' && warningsThirdLayer.find(warning => warning.type === 'depSlot' || warning.type === 'arrSlot')) {
                    tmp_warningsSecondLayer.push({
                        type: 'slotIssue',
                        text: 'Slot Issue',
                        icon: 'mdi-timer-alert'
                    });
                }

                // >>> 'LAYER 2: Departure Slot Warning' ---------------------------
                if (rotation.type !== 'missingFlight' && warningsThirdLayer.find(warning => warning.type === 'collisionCheck')) {
                    tmp_warningsSecondLayer.push({
                        type: 'collisionCheck',
                        text: 'Warning on Leg',
                        icon: 'mdi-airplane-alert'
                    });
                }

                if (warningsThirdLayer.find(warning => warning.type === 'deleted')) {
                    tmp_warningsSecondLayer.push({
                        type: 'deleted',
                        text: 'Flight Deleted',
                        icon: 'mdi-trash-can'
                    });
                }

                rotation.warnings = tmp_warningsSecondLayer;
                tmp_warningsSecondLayer.forEach(t => {
                    warningsSecondLayer.push(t);
                });

            });
            // <<< LAYER 2 EXIT (ROTATIONS) ------------------------------------

            // >>> 'LAYER 1: Add missing Days to children' ---------------------
            missingDays.forEach(missingDay => {
                chain.children.splice(missingDay.index, 0, missingDay.data);
            });

            // >>> 'LAYER 1: Different Schedule' -------------------------------
            if (warningsSecondLayer.find(warning => warning.type === 'differentSchedule')) {
                warningsFirstLayer.push({
                    type: 'differentSchedule',
                    text: 'Different Schedule',
                    icon: 'mdi-airplane-clock'
                });
            }

            // >>> 'LAYER 1: Interrupted Chain Warning' ------------------------
            if (missingDays.length > 0) {
                warningsFirstLayer.push({
                    type: 'interruptedChain',
                    text: 'Interrupted Chain',
                    icon: 'mdi-list-status'
                });
            }

            // >>> 'LAYER 1: Departure Slot Warning' ---------------------------
            if (warningsSecondLayer.find(warning => warning.type === 'slotIssue')) {
                warningsFirstLayer.push({
                    type: 'slotIssue',
                    text: 'Slot Issue',
                    icon: 'mdi-timer-alert'
                });
            }

            // >>> 'LAYER 1: Departure Slot Warning' ---------------------------
            if (warningsSecondLayer.find(warning => warning.type === 'collisionCheck')) {
                warningsFirstLayer.push({
                    type: 'collisionCheck',
                    text: 'Warning on Leg',
                    icon: 'mdi-airplane-alert'
                });
            }

            if (warningsSecondLayer.find(warning => warning.type === 'deleted')) {
                warningsFirstLayer.push({
                    type: 'deleted',
                    text: 'Flight Deleted',
                    icon: 'mdi-trash-can'
                });
            }

            chain.warnings = warningsFirstLayer;

        });
        // <<< LAYER 1 EXIT (CHAIN) --------------------------------------------

        state.slotmanagement_flightsTable_rotations_chain_Filtered = flightChains;

    }, // eo function mut_createWarnings()

    /***************************************************************************
    * Actions: 'Slotmanagement' - Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * mut_set_filter_filterTerm()
    *
    * Desc: Simply set/save 'slotmanagement_filterTerm'.
    * Note:
    *
    */
    mut_set_filter_filterTerm: (state, payload) => {

        state.slotmanagement_filterTerm = payload; // save

    }, // eo function mut_set_filter_filterTerm()

    /***************************************************************************
    * mut_set_filterSlots_filterTerm()
    *
    * Desc: Simply set/save 'slotmanagement_filterTerm'.
    * Note:
    *
    */
    mut_set_filterSlots_filterTerm: (state, payload) => {

        state.slotmanagement_filterTerm = payload; // save

    }, // eo function mut_set_filterSlots_filterTerm()

    /***************************************************************************
    * mut_filter_Flights()
    *
    * Desc: (Re)build 'new' 'slotmanagement_flights_Filtered'.
    * Note:
    *
    */
    mut_filter_Flights: (state) => {

        // >>> 'filterFlightNumber' -------------------------
        const filterFlightNumber = (resource) => {

            let applyFilter = false;

            // TODO: we cant split VIA or TRIA flights yet (so disable filter)
            if (resource.flightType === 'V' || resource.flightType === 'T') {
                return true;
            }

            if (state.slotmanagement_filterTerm.flightNumber && state.slotmanagement_filterTerm.flightNumber !== '') {
                if (resource.flightNo.match(new RegExp(state.slotmanagement_filterTerm.flightNumber, 'i'))) {
                    applyFilter = true;
                }
                if (resource.flightNo.match(new RegExp(state.slotmanagement_filterTerm.flightNumber, 'i'))) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.slotmanagement_filterTerm.flightNumber === '') {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'departureAirport' -------------------------
        const filterDepartureAirport = (resource) => {

            let applyFilter = false;

            // TODO: we cant split VIA or TRIA flights yet (so disable filter)
            if (resource.flightType === 'V' || resource.flightType === 'T') {
                return true;
            }

            if (state.slotmanagement_filterTerm.departureAirport && state.slotmanagement_filterTerm.departureAirport !== null) {

                if (state.slotmanagement_filterTerm.destinationAirport === state.slotmanagement_filterTerm.departureAirport) {
                    if (resource.aptFrom.aptCode === state.slotmanagement_filterTerm.departureAirport || resource.aptTo.aptCode === state.slotmanagement_filterTerm.destinationAirport) {
                        applyFilter = true;
                    }
                } else {
                    if (resource.aptFrom.aptCode === state.slotmanagement_filterTerm.departureAirport) {
                        applyFilter = true;
                    }
                }

            }

            // if there is set no search term
            if (state.slotmanagement_filterTerm.departureAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'destinationAirport' -------------------------
        const filterDestinationAirport = (resource) => {
            let applyFilter = false;

            // TODO: we cant split VIA or TRIA flights yet (so disable filter)
            if (resource.flightType === 'V' || resource.flightType === 'T') {
                return true;
            }

            if (state.slotmanagement_filterTerm.destinationAirport && state.slotmanagement_filterTerm.destinationAirport !== null) {
                if (state.slotmanagement_filterTerm.destinationAirport === state.slotmanagement_filterTerm.departureAirport) {
                    if (resource.aptFrom.aptCode === state.slotmanagement_filterTerm.departureAirport || resource.aptTo.aptCode === state.slotmanagement_filterTerm.destinationAirport) {
                        applyFilter = true;
                    }
                } else {
                    if (resource.aptTo.aptCode === state.slotmanagement_filterTerm.destinationAirport) {
                        applyFilter = true;
                    }
                }

            }

            // if there is set no search term
            if (state.slotmanagement_filterTerm.destinationAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'slotStatus' -------------------------
        const filterSlotStatus = (resource) => {
            let applyFilter = false;


            if (state.slotmanagement_filterTerm.slotStatus && state.slotmanagement_filterTerm.slotStatus.length !== 0) {
                if (resource.depSlotStatus === null) {
                    resource.depSlotStatus = 'OPEN';
                }
                if (resource.arrSlotStatus === null) {
                    resource.arrSlotStatus = 'OPEN';
                }
                if (state.slotmanagement_filterTerm.slotStatus.includes(resource.depSlotStatus)) {
                    applyFilter = true;
                }
                if (state.slotmanagement_filterTerm.slotStatus.includes(resource.arrSlotStatus)) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.slotmanagement_filterTerm.slotStatus.length === 0) {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'aircrafts' -------------------------
        const filterAircrafts = (resource) => {
            let applyFilter = false;


            if (state.slotmanagement_filterTerm.aircrafts && state.slotmanagement_filterTerm.aircrafts.length !== 0) {
                if (state.slotmanagement_filterTerm.aircrafts.includes(resource.idAircraft)) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.slotmanagement_filterTerm.aircrafts.length === 0) {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'days' -------------------------
        const filterDays = (resource) => {
            let applyFilter = false;


            if (state.slotmanagement_filterTerm.days && state.slotmanagement_filterTerm.days.length !== 0) {
                if (state.slotmanagement_filterTerm.days.includes(dayjs(resource.departureTime).utc().get('day'))) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.slotmanagement_filterTerm.days.length === 0) {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'deleted' -------------------------
        const filterDeleted = (resource) => {
            let applyFilter = false;


            if (state.slotmanagement_filterTerm.deletedFlights === true) {
                if (resource.deleted !== null) {
                    applyFilter = true; // deleted filter set to true means "show all flights"
                }
            }

            if (state.slotmanagement_filterTerm.deletedFlights === false) {
                if (resource.deleted === null) {
                    applyFilter = true;
                }
            }

            return applyFilter;
        };


        // >>> Rebuild ------------------------------------
        state.slotmanagement_flights_Filtered = state.slotmanagement_flights.filter(resource => filterDepartureAirport(resource));
        state.slotmanagement_flights_Filtered = state.slotmanagement_flights_Filtered.filter(resource => filterDestinationAirport(resource));
        state.slotmanagement_flights_Filtered = state.slotmanagement_flights_Filtered.filter(resource => filterFlightNumber(resource));
        state.slotmanagement_flights_Filtered = state.slotmanagement_flights_Filtered.filter(resource => filterAircrafts(resource));
        state.slotmanagement_flights_Filtered = state.slotmanagement_flights_Filtered.filter(resource => filterDays(resource));
        state.slotmanagement_flights_Filtered = state.slotmanagement_flights_Filtered.filter(resource => filterDeleted(resource));


    }, // eo function mut_filter_Flights()

    /***************************************************************************
    * mut_filter_Rotations()
    *
    * Desc: (Re)build 'new' 'slotmanagement_flights_Filtered'.
    * Note:
    *
    */
    mut_filter_Rotations: (state) => {

        // >>> 'filterFlightNumber' -------------------------
        const filterFlightNumber = (chains) => {

            let applyFilter = false;


            chains.children.forEach(rotation => {
                rotation.children.forEach(flight => {
                    if (state.slotmanagement_filterTerm.flightNumber && state.slotmanagement_filterTerm.flightNumber !== '') {
                        if (flight.leg.flightNo.match(new RegExp(state.slotmanagement_filterTerm.flightNumber, 'i'))) {
                            applyFilter = true;
                        }
                        if (flight.leg.flightNo.match(new RegExp(state.slotmanagement_filterTerm.flightNumber, 'i'))) {
                            applyFilter = true;
                        }
                    }
                });
            });

            // if there is set no search term
            if (state.slotmanagement_filterTerm.flightNumber === '') {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'departureAirport' -------------------------
        const filterDepartureAirport = (chains) => {
            let applyFilter = false;

            chains.children.forEach(rotation => {
                rotation.children.forEach(flight => {
                    if (state.slotmanagement_filterTerm.departureAirport && state.slotmanagement_filterTerm.departureAirport !== null) {
                        if (state.slotmanagement_filterTerm.destinationAirport === state.slotmanagement_filterTerm.departureAirport) {
                            if (flight.leg.aptFrom.aptCode === state.slotmanagement_filterTerm.departureAirport || flight.leg.aptTo.aptCode === state.slotmanagement_filterTerm.destinationAirport) {
                                applyFilter = true;
                            }
                        } else {
                            if (flight.leg.aptFrom.aptCode === state.slotmanagement_filterTerm.departureAirport) {
                                applyFilter = true;
                            }
                        }

                    }
                });
            });

            // if there is set no search term
            if (state.slotmanagement_filterTerm.departureAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'destinationAirport' -------------------------
        const filterDestinationAirport = (chains) => {
            let applyFilter = false;

            chains.children.forEach(rotation => {
                rotation.children.forEach(flight => {
                    if (state.slotmanagement_filterTerm.destinationAirport && state.slotmanagement_filterTerm.destinationAirport !== null) {
                        if (state.slotmanagement_filterTerm.destinationAirport === state.slotmanagement_filterTerm.departureAirport) {
                            if (flight.leg.aptTo.aptCode === state.slotmanagement_filterTerm.destinationAirport || flight.leg.aptFrom.aptCode === state.slotmanagement_filterTerm.departureAirport) {
                                applyFilter = true;
                            }
                        } else {
                            if (flight.leg.aptTo.aptCode === state.slotmanagement_filterTerm.destinationAirport) {
                                applyFilter = true;
                            }
                        }

                    }
                });
            });

            // if there is set no search term
            if (state.slotmanagement_filterTerm.destinationAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        // >>> Rebuild ------------------------------------
        state.slotmanagement_flightsTable_rotations_chain_Filtered = state.slotmanagement_flightsTable_rotations_chain.filter(resource => filterFlightNumber(resource));
        state.slotmanagement_flightsTable_rotations_chain_Filtered = state.slotmanagement_flightsTable_rotations_chain_Filtered.filter(resource => filterDepartureAirport(resource));
        state.slotmanagement_flightsTable_rotations_chain_Filtered = state.slotmanagement_flightsTable_rotations_chain_Filtered.filter(resource => filterDestinationAirport(resource));


    }, // eo function mut_filter_Rotations()

    /***************************************************************************
    * mut_set_flightTable_selectedFlights()
    *
    * Desc: Save 'Blocktimes' (unfiltered).
    * Note:
    *
    */
    mut_set_flightTable_selectedFlights: (state, payload) => {

        state.slotmanagement_flightsTable_selectedFlights = payload;

    }, // eo function mut_set_flightTable_selectedFlights()

    /***************************************************************************
    * mut_set_slotsTable_selectedSlots()
    *
    * Desc: Simply set/save 'slotmanagement_filterTerm'.
    * Note:
    *
    */
    mut_set_slotsTable_selectedSlots: (state, payload) => {

        state.slotmanagement_slotsTable_selectedSlots = payload;

    }, // eo function mut_set_slotsTable_selectedSlots()

    /***************************************************************************
    * mut_call_rebuildSlots()
    *
    * Desc:
    * Note:
    *
    */
    mut_slotsTable_rebuildSlots: (state, payload) => {

        payload.context.commit('mut_slotsTable_groupSlotChangeLogs', payload); // rebuild
        // payload.context.commit('mut_slotsTable_buildEvents', payload); // rebuild
        payload.context.commit('mut_slotsTable_buildRotationsAndChains'); // rebuild
        payload.context.commit('mut_slotsTable_filterSlotsRotation'); // rebuild
        payload.context.commit('mut_slotsTable_sortSlots');

    }, // mut_call_rebuildSlots

    /***************************************************************************
    *  mut_slotsTable_buildRotationsAndChains()
    *
    * Desc: Groups 'slots' by 'idFlightSegment' & 'direction'.
    * Note: /slots/list is a change log of slots.
    *
    */
    mut_slotsTable_groupSlotChangeLogs: (state, payload) => {

        const getSlotsCopy = JSON.parse(JSON.stringify(state.slotmanagement_slotsTable_getSlots)),
            groupedSlots = [];
        let filteredGroupedSlots = [];

        /***************************************************************************
        * helper_buildSlotProperty()
        *
        * Desc: Builds the slot message
        * Note: TODO: put into global function (is used in flights AND slotmanagment)
        *
        */
        const helper_buildSlotProperty = (slot) => {

            let slotMessage = '';

            if (slot.direction === 'DEPARTURE') {
                slotMessage = `${dayjs(slot.slotTime).utc().format('HHmm')}${slot.airport.aptCode}`;
            } else {
                slotMessage = `${slot.airport.aptCode}${dayjs(slot.slotTime).utc().format('HHmm')}`;
            }

            return slotMessage;
        }; // helper_buildSlotProperty

        /***********************************************************************
        * helper_getNewSlotValue
        *
        * Desc: Takes change logs and change type and returns the new value
        * Note:
        *
        */
        const helper_getNewSlotValue = (changeLogs, type) => {

            let foundLog = null;
            if (!changeLogs) {
                return '';
            }
            foundLog = changeLogs.find(log => log.type === type);

            return foundLog ? foundLog.newValue : '';
        };// eo function helper_getNewSlotValue()

        // >>> Group by 'idFlightSegment' & 'direction' ------------------------
        getSlotsCopy.forEach(slot => {

            const keySlot = `${slot.idFlightSegment}-${slot.direction}`, // create key
                indexSlot = groupedSlots.findIndex(slot => slot.key === keySlot && slot.idFlightSegment !== null); // find index of slot

            slot.airportSlot = payload.context.rootState.airports.airports_airports.find(a => a.iataCode === slot.airportSlot);
            slot.airport = payload.context.rootState.airports.airports_airports.find(a => a.iataCode === slot.airport);
            slot.aircraftType = payload.context.rootState.shared.people_aircraftConfigs.find(a => a.idAircraft === slot.aircraftType);
            if (slot.type === 'changeAircraft') {
                slot.newValue = payload.context.rootState.shared.people_aircraftConfigs.find(a => a.id === +slot.newValue);
                slot.oldValue = payload.context.rootState.shared.people_aircraftConfigs.find(a => a.id === +slot.oldValue);
            }
            if (slot.type === 'airport') {
                slot.newValue = payload.context.rootState.airports.airports_airports.find(a => a.iataCode === slot.newValue);
                slot.oldValue = payload.context.rootState.airports.airports_airports.find(a => a.iataCode === slot.oldValue);
            }
            if (slot.type === 'retiming') {
                slot.oldValue = slot.slotTime;
            }
            slot.date = dayjs(slot.slotTime).utc().format('YYYY-MM-DD');
            slot.time = dayjs(slot.slotTime).utc().format('HH:mm');
            slot.slot = helper_buildSlotProperty(slot);
            slot.layer = 3;
            if (slot.mainServiceType === null) {
                slot.mainServiceType = 'C';
            }

            // extend slot object with 'key' property
            slot = {
                key: keySlot,
                ...slot
            };
            // if slot already exists
            if (indexSlot >= 0) {
                const keyChange = slot.type,
                   indexChange = groupedSlots[indexSlot].slotChangeLogs.findIndex(slotChangeLog => slotChangeLog.type === keyChange);
                // if slotChangeLog already exists
                if (indexChange >= 0) {
                    // update slotChangeLog
                    groupedSlots[indexSlot].slotChangeLogs[indexChange].newValue = slot.newValue;
                    groupedSlots[indexSlot].slotChangeLogs[indexChange].changeDate = slot.changeDate;
                    groupedSlots[indexSlot].slotChangeLogs[indexChange].slotIds.push(slot.id);
                // if slotChangeLog does not exist
                } else {
                    // create new slotChangeLog
                    groupedSlots[indexSlot].slotChangeLogs.push({
                        type: slot.type,
                        oldValue: slot.oldValue,
                        newValue: slot.newValue,
                        changeDate: slot.changeDate,
                        slotIds: [slot.id]
                    });
                }
            // if slot does not exist
            } else {
                // create new slotChangeLog
                slot.slotChangeLogs = [{
                    type: slot.type,
                    oldValue: slot.oldValue,
                    newValue: slot.newValue,
                    changeDate: slot.changeDate,
                    slotIds: [slot.id]
                }];
                // create new slot
                groupedSlots.push(slot);
            }
        });

        // get latest change for all changeable properties
        groupedSlots.forEach(slot => {
            slot.changedAircraft = helper_getNewSlotValue(slot.slotChangeLogs, 'changeAircraft');
            slot.changedFlightNo = [helper_getNewSlotValue(slot.slotChangeLogs, 'flightNo')];
            slot.changedTime = helper_getNewSlotValue(slot.slotChangeLogs, 'retiming') ? Vue.prototype.$dayjsLocalToUTC(helper_getNewSlotValue(slot.slotChangeLogs, 'retiming'), 'HHmm') : Vue.prototype.$dayjsLocalToUTC(slot.slotTime, 'HHmm');
            slot.changedAirport = helper_getNewSlotValue(slot.slotChangeLogs, 'airport') ? helper_getNewSlotValue(slot.slotChangeLogs, 'airport').aptCode : slot.airport.aptCode;
            slot.changedSlot = [(helper_getNewSlotValue(slot.slotChangeLogs, 'airport') || helper_getNewSlotValue(slot.slotChangeLogs, 'retiming')) ? (`${slot.direction === 'DEPARTURE' ? slot.changedTime + slot.changedAirport : slot.changedAirport + slot.changedTime}`) : ''];
        });

        // filter unnecessary slot changes which has no real changed (happens if you change smth on a flight and change it back to original)
        filteredGroupedSlots = groupedSlots.map(slot => {
            slot.slotChangeLogs = slot.slotChangeLogs.filter(s => s.newValue !== s.oldValue);
            slot.slotChangeLogs = slot.slotChangeLogs.filter(s => s.type !== 'retiming' || s.newValue !== s.slotTime);
            return slot;
        });
        filteredGroupedSlots = filteredGroupedSlots.filter(s => s.status === 'DELETE' || s.slotChangeLogs.length > 0);
        state.slotmanagement_slotsTable_slots = filteredGroupedSlots.sort((a, b) => new Date(a.slotTime) - new Date(b.slotTime));

    }, // eo function mut_slotsTable_groupSlotChangeLogs()

    /***************************************************************************
    * mut_slotsTable_buildRotationsAndChains()
    *
    * Desc: Group single slots into rotations and chains
    * Note:
    * @param {Object} state - The state object containing the slots table data.
    * @param {Object} payload - The payload object containing additional data.
    */
    mut_slotsTable_buildRotationsAndChains: (state, payload) => {

        const me = this,
              keysRotation = ['airportSlot', 'airport', 'slotTime', 'direction'],
              keysChain = ['flightNo', 'airportSlot', 'airport', 'slotTime'];

        /***************************************************************************
        * helper_buildRotationsAndChains_buildWarnings()
        *
        * Desc:
        * Note:
        *
        */
        const helper_buildRotationsAndChains_buildWarnings = (slot) => {

            const warnings = [];
            let warning = {};

            if (dayjs(slot.slotTime).isSameOrBefore(dayjs().add(2, 'day'), 'day')) {

                warning = {
                    icon: 'mdi-clock-alert',
                    text: 'Slot expires'
                };
                warnings.push(warning);
            }

            return warnings;

        }; // eo function helper_buildRotationsAndChains_buildWarnings()

        /***********************************************************************
            * getNewSlotValue
            *
            * Desc: Takes change logs and change type and returns the new value
            * Note:
            *
            */
        const getNewSlotValue = (changeLogs, type) => {

            let foundLog = null;
            foundLog = changeLogs.find(log => log.type === type);

            return foundLog ? foundLog.newValue : '';
        };// eo function getNewSlotValue()

        // combine rotations
        const rotations = state.slotmanagement_slotsTable_slots.reduce((acc, obj) => {
            const value = keysRotation.map(key => obj[key]);
            const index = acc.findIndex(item => keysRotation.every((key, i) => {

                if (key === 'slotTime') {
                    return Math.abs(dayjs(value[i]).diff(dayjs(item[key]), 'hours')) < 14;
                } else if (key === 'direction') {
                    return item[key] !== value[i];
                } else {
                    return item[key] === value[i];
                }
            }));

            if (index >= 0) {
                acc[index].direction = 'ROTATION';
                acc[index].flightNo.push(obj.flightNo);
                acc[index].slot.push(obj.slot);
                acc[index].status += acc[index].status !== obj.status ? ` / ${obj.status}` : '';
                acc[index].children.sort((a, b) => new Date(a.slotTime) - new Date(b.slotTime));
                acc[index].children.push(obj);
                // acc[index].changedAircraft += ` ${getNewSlotValue(obj.slotChangeLogs, 'changeAircraft').code}`;
                acc[index].changedFlightNo.push(getNewSlotValue(obj.slotChangeLogs, 'flightNo') ? getNewSlotValue(obj.slotChangeLogs, 'flightNo') : '');
                acc[index].changedAirport = getNewSlotValue(obj.slotChangeLogs, 'airport') ? getNewSlotValue(obj.slotChangeLogs, 'airport') : obj.airport.aptCode;
                acc[index].changedTime = getNewSlotValue(obj.slotChangeLogs, 'retiming') ? Vue.prototype.$dayjsLocalToUTC(getNewSlotValue(obj.slotChangeLogs, 'retiming'), 'HHmm') : Vue.prototype.$dayjsLocalToUTC(obj.slotTime, 'HHmm');
                acc[index].changedSlot.push((getNewSlotValue(obj.slotChangeLogs, 'airport') || getNewSlotValue(obj.slotChangeLogs, 'retiming')) ? (`${obj.direction === 'DEPARTURE' ? acc[index].changedTime + acc[index].changedAirport : acc[index].changedAirport + acc[index].changedTime}`) : '');
                acc.sort((a, b) => new Date(a.slotTime) - new Date(b.slotTime));
            } else {
                const item = {};
                keysRotation.forEach((key, i) => { item[key] = value[i]; });
                item.id = `rotation-${obj.id}`;
                item.layer = 2;
                item.flightNo = [obj.flightNo];
                item.slot = [obj.slot];
                item.aircraftType = obj.aircraftType;
                item.status = obj.status;
                item.warnings = helper_buildRotationsAndChains_buildWarnings(obj);
                item.changedAircraft = getNewSlotValue(obj.slotChangeLogs, 'changeAircraft');
                item.changedFlightNo = [getNewSlotValue(obj.slotChangeLogs, 'flightNo')];
                item.changedTime = getNewSlotValue(obj.slotChangeLogs, 'retiming') ? Vue.prototype.$dayjsLocalToUTC(getNewSlotValue(obj.slotChangeLogs, 'retiming'), 'HHmm') : Vue.prototype.$dayjsLocalToUTC(obj.slotTime, 'HHmm');
                item.changedAirport = getNewSlotValue(obj.slotChangeLogs, 'airport') ? getNewSlotValue(obj.slotChangeLogs, 'airport').aptCode : obj.airport.aptCode;
                item.changedSlot = [(getNewSlotValue(obj.slotChangeLogs, 'airport') || getNewSlotValue(obj.slotChangeLogs, 'retiming')) ? (`${obj.direction === 'DEPARTURE' ? item.changedTime + item.changedAirport : item.changedAirport + item.changedTime}`) : ''];
                item.children = [obj];
                acc.push(item);
                acc.sort((a, b) => new Date(a.slotTime) - new Date(b.slotTime));
            }

            return acc;
        }, []);

        // combine chains
        const chains = rotations.reduce((acc, obj) => {
            const value = keysChain.map(key => obj[key]);
            const index = acc.findIndex(item => keysChain.every((key, i) => {
                if (key === 'slotTime') {
                    return Math.abs(dayjs(value[i]).diff(dayjs(item[key]), 'days')) === 7;
                } else if (key === 'flightNo') {
                    return JSON.stringify(item[key]) === JSON.stringify(value[i]);
                } else {
                    return item[key] === value[i];
                }
            }));

            if (index >= 0) {
                acc[index].dateRange = `${dayjs(acc[index].children[0].slotTime).format('DD.MM.YYYY')} - ${dayjs(obj.slotTime).format('DD.MM.YYYY')}`;
                // acc[index].status += ` / ${obj.status}`;
                acc[index].children.push(obj);
                acc[index].children.sort((a, b) => new Date(a.slotTime) - new Date(b.slotTime));
                acc.sort((a, b) => new Date(a.slotTime) - new Date(b.slotTime));
            } else {
                const item = {};
                keysChain.forEach((key, i) => { item[key] = value[i]; });
                item.id = `chain-${obj.id}`;
                item.layer = 1;
                item.dateRange = dayjs(obj.slotTime).format('DD.MM.YYYY');
                item.slot = obj.slot;
                item.aircraftType = obj.aircraftType;
                item.status = obj.status;
                item.warnings = obj.warnings;
                item.changedAircraft = obj.changedAircraft;
                item.changedFlightNo = obj.changedFlightNo;
                item.changedAirport = obj.changedAirport;
                item.changedTime = obj.changedTime;
                item.changedSlot = obj.changedSlot;
                item.children = [obj];
                acc.push(item);
                acc.sort((a, b) => new Date(a.slotTime) - new Date(b.slotTime));
            }

            return acc;
        }, []);

        state.slotmanagement_slotsTable_rotations_chain = chains;

    }, // mut_slotsTable_buildRotationsAndChains

    /***************************************************************************
    * mut_slotsTable_sortSlots()
    *
    * Desc: (Re)build 'new' 'slotmanagement_flights_Filtered'.
    * Note:
    *
    */
    mut_slotsTable_sortSlots: (state) => {

        state.slotmanagement_slotsTable_slots_Filtered =
            state.slotmanagement_slotsTable_slots_Filtered
                .sort((a, b) =>
                    a.slotTime < b.slotTime ? -1 : 1);

    }, // eo function mut_slotsTable_sortSlots()

    /***************************************************************************
    * mut_slotsTable_filterSlotsRotation()
    *
    * Desc: (Re)build 'new' 'slotmanagement_slotsTable_slots'.
    * Note:
    *
    */
    mut_slotsTable_filterSlotsRotation: (state) => {

        // >>> 'filterFilterTerm' -------------------------
        const filterFlightNumber = (chains) => {
            let applyFilter = false;

            chains.children.forEach(rotation => {
                rotation.children.forEach(slot => {
                    if (state.slotmanagement_filterTerm.flightNumber && state.slotmanagement_filterTerm.flightNumber !== '') {
                        if (slot.flightNo.match(new RegExp(state.slotmanagement_filterTerm.flightNumber, 'i'))) {
                            applyFilter = true;
                        }
                        if (slot.flightNo.match(new RegExp(state.slotmanagement_filterTerm.flightNumber, 'i'))) {
                            applyFilter = true;
                        }
                    }
                });
            });

            // if there is set no search term
            if (state.slotmanagement_filterTerm.flightNumber === '') {
                applyFilter = true;
            }

            return applyFilter;
        };

        // >>> 'departureAirport' -------------------------
        const filterDepartureAirport = (chains) => {
            let applyFilter = false;

            chains.children.forEach(rotation => {
                rotation.children.forEach(slot => {
                    if (state.slotmanagement_filterTerm.departureAirport && state.slotmanagement_filterTerm.departureAirport !== null) {
                        if (state.slotmanagement_filterTerm.destinationAirport === state.slotmanagement_filterTerm.departureAirport) {
                            if (slot.airportSlot.aptCode === state.slotmanagement_filterTerm.departureAirport || slot.airportSlot.aptCode === state.slotmanagement_filterTerm.destinationAirport) {
                                applyFilter = true;
                            }
                        } else {
                            if (slot.airportSlot.aptCode === state.slotmanagement_filterTerm.departureAirport) {
                                applyFilter = true;
                            }
                        }
                    }
                });
            });

            // if there is set no search term
            if (state.slotmanagement_filterTerm.departureAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };
        // >>> 'destinationAirport' -------------------------
        const filterDestinationAirport = (chains) => {
            let applyFilter = false;

            chains.children.forEach(rotation => {
                rotation.children.forEach(slot => {
                    if (state.slotmanagement_filterTerm.destinationAirport && state.slotmanagement_filterTerm.destinationAirport !== null) {
                        if (state.slotmanagement_filterTerm.destinationAirport === state.slotmanagement_filterTerm.departureAirport) {
                            if (slot.airportSlot.aptCode === state.slotmanagement_filterTerm.departureAirport || slot.airportSlot.aptCode === state.slotmanagement_filterTerm.destinationAirport) {
                                applyFilter = true;
                            }
                        } else {
                            if (slot.airportSlot.aptCode === state.slotmanagement_filterTerm.destinationAirport) {
                                applyFilter = true;
                            }
                        }
                    }
                });
            });

            // if there is set no search term
            if (state.slotmanagement_filterTerm.destinationAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        // >>> 'days' -------------------------
        const filterDays = (chains) => {
            let applyFilter = false;

            chains.children.forEach(rotation => {
                rotation.children.forEach(slot => {
                    if (state.slotmanagement_filterTerm.days && state.slotmanagement_filterTerm.days.length !== 0) {
                        if (state.slotmanagement_filterTerm.days.includes(dayjs(slot.slotTime).get('day'))) {
                            applyFilter = true;
                        }
                    }

                    // if there is set no search term
                    if (state.slotmanagement_filterTerm.days.length === 0) {
                        applyFilter = true;
                    }
                });
            });

            return applyFilter;
        };
        // >>> 'aircraft' -------------------------
        const filterAircrafts = (chains) => {
            let applyFilter = false;

            chains.children.forEach(rotation => {
                rotation.children.forEach(slot => {
                    if (state.slotmanagement_filterTerm.aircrafts && state.slotmanagement_filterTerm.aircrafts.length !== 0) {
                        if (state.slotmanagement_filterTerm.aircrafts.includes(slot.aircraftType.idAircraft)) {
                            applyFilter = true;
                        }
                    }
                });
            });

            // if there is set no search term
            if (state.slotmanagement_filterTerm.departureAirport === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        // >>> Rebuild ------------------------------------
        state.slotmanagement_slotsTable_Rotations_Chain_Filtered = state.slotmanagement_slotsTable_rotations_chain.filter(resource => filterFlightNumber(resource));
        state.slotmanagement_slotsTable_Rotations_Chain_Filtered = state.slotmanagement_slotsTable_Rotations_Chain_Filtered.filter(resource => filterDepartureAirport(resource));
        state.slotmanagement_slotsTable_Rotations_Chain_Filtered = state.slotmanagement_slotsTable_Rotations_Chain_Filtered.filter(resource => filterDestinationAirport(resource));
        state.slotmanagement_slotsTable_Rotations_Chain_Filtered = state.slotmanagement_slotsTable_Rotations_Chain_Filtered.filter(resource => filterDays(resource));
        state.slotmanagement_slotsTable_Rotations_Chain_Filtered = state.slotmanagement_slotsTable_Rotations_Chain_Filtered.filter(resource => filterAircrafts(resource));

    }, // eo function mut_slotsTable_filterSlotsRotation()

    /***************************************************************************
    * mut_call_slotsTable_getSlots()
    *
    * Desc: (Re)build 'new' 'slotmanagement_flights_Filtered'.
    * Note: Filter inactive aircrafts
    *
    */
    mut_call_slotsTable_getSlots: (state, payload) => {
        // filter not inactive aircraft
        state.slotmanagement_slotsTable_getSlots = payload.payload.filter(slot => payload.context.rootState.shared.people_aircraftConfigs.find(a => a.idAircraft === slot.aircraftType));
        state.slotmanagement_slotsTable_getSlots = state.slotmanagement_slotsTable_getSlots.filter(slot => slot.type !== 'changeAircraft' || payload.context.rootState.shared.people_aircraftConfigs.find(a => a.id === +slot.newValue));
        state.slotmanagement_slotsTable_getSlots = state.slotmanagement_slotsTable_getSlots.filter(slot => slot.type !== 'changeAircraft' || payload.context.rootState.shared.people_aircraftConfigs.find(a => a.id === +slot.oldValue));
        // filter not inactive aircraft
        state.slotmanagement_slotsTable_getSlots = state.slotmanagement_slotsTable_getSlots.map(slot => {
            // historically conditioned.. mainServiceType was once type boolean
            if (slot.mainServiceType === '0' || slot.mainServiceType === null) {
                slot.mainServiceType = 'C';
            }
            return slot;
        });
        payload.payload = state.slotmanagement_slotsTable_getSlots;

        payload.context.commit('mut_slotsTable_rebuildSlots', payload);

    }, // eo mut_call_slotsTable_getSlots

    /***************************************************************************
    * mut_call_slotsTable_createUpdateSlots()
    *
    * Desc: (Re)build 'new' 'slotmanagement_flights_Filtered'.
    * Note:
    *
    */
    mut_call_slotsTable_createUpdateSlots: (state, payload) => {

        // >>> New Legs into flights_Legs State ------------------------
        state.slotmanagement_slotsTable_getSlots =
        state.slotmanagement_slotsTable_getSlots
            .filter(
                slot =>
                    payload.payload
                        .find(payloadslot => payloadslot.id === slot.id) === undefined
            ); // delete "old" updated flights
        payload.payload.forEach((slot) => {
            slot.wasEdited = true;
        });
        state.slotmanagement_slotsTable_getSlots = state.slotmanagement_slotsTable_getSlots.concat(payload.payload); // add "new" updated flights

        payload.context.commit('mut_slotsTable_rebuildSlots', payload);
        eventBus.$emit('slotcreatedupdated');

    }, // eo mut_call_slotsTable_createUpdateSlots

    /***************************************************************************
    * mut_call_slotmanagement_deleteSlots()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_slotmanagement_deleteSlots: (state, payload) => {

        // >>> New Legs into flights_Legs State ------------------------
        state.slotmanagement_slotsTable_getSlots =
        state.slotmanagement_slotsTable_getSlots
            .filter(
                slot =>
                    payload.payload
                        .find(payloadslot => payloadslot.id === slot.id) === undefined
            ); // delete "old" updated flights

        payload.context.commit('mut_slotsTable_rebuildSlots', payload);

    } // eo mut_call_slotmanagement_deleteSlots

};





//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Slotmanagement', Call: Get Flights
    ***************************************************************************/
    /***************************************************************************
    * Call::'/acm/forms/getlegsinfo'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_getFlights: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/acm/forms/getlegsinfo', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getFlights', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getFlights()


    /***************************************************************************
    * Call::'/acm/flightplanning/flight/update'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_slotmanagement_updateFlights: (context, payload) => {

        let hdrs = '';

        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/acm/flightplanning/flight/update', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_slotmanagement_updateFlights', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_slotmanagement_updateFlights()

    /***************************************************************************
    * Call::'/acm/slots'
    *
    * Desc:
    * Note:
    *
    */
     actn_call_slotmanagement_getSlots: (context, payload) => {

        let hdrs = '';

        // >>> Send Ajax Request --------------------------
        // Vue.prototype.$vp_m();
        axios.put('/acm/slots/list', payload)
            .then(function (response) { // 'OK'
                // Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_slotsTable_getSlots', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                // Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_slotmanagement_getSlots()

    /***************************************************************************
    * Call::'/acm/slots'
    *
    * Desc:
    * Note:
    *
    */
     actn_call_slotmanagement_createUpdateSlots: (context, payload) => {

        let hdrs = '';

        // >>> Send Ajax Request --------------------------
        if (payload.loadingMask) {
            Vue.prototype.$vp_m();
        }
        axios.put('/acm/slots', payload.payload)
            .then(function (response) { // 'OK'
                if (payload.loadingMask) {
                    Vue.prototype.$vp_um();
                }
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_slotsTable_createUpdateSlots', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                if (payload.loadingMask) {
                    Vue.prototype.$vp_um();
                }
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_slotmanagement_createUpdateSlots()

    /***************************************************************************
    * Call::'/acm/slots/delete'
    *
    * Desc:
    * Note:
    *
    */
     actn_call_slotmanagement_deleteSlots: (context, payload) => {

        let hdrs = '';

        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/acm/slots/delete', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_slotmanagement_deleteSlots', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_slotmanagement_deleteSlots()

    /***************************************************************************
    * actn_set_flightTable_selectedFlights()
    *
    * Desc:
    * Note:
    *
    */
     actn_set_flightTable_selectedFlights: (context, payload) => {

        context.commit('mut_set_flightTable_selectedFlights', payload);

    }, // eo function actn_set_flightTable_selectedFlights()

    /***************************************************************************
    * actn_set_slotsTable_selectedSlots()
    *
    * Desc:
    * Note:
    *
    */
    actn_set_slotsTable_selectedSlots: (context, payload) => {

        context.commit('mut_set_slotsTable_selectedSlots', payload);

    }, // eo function actn_set_slotsTable_selectedSlots()

    /***************************************************************************
    * Actions: 'Slotmanagement' - Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * actn_set_filter_filterTerm()
    *
    * Desc: Set 'filter Terms' and 'refilter'.
    * Note:
    *
    */
     actn_set_filter_filterTerm: (context, payload) => {

         context.commit('mut_set_filter_filterTerm', payload); // save term
        // Flights Table
        context.commit('mut_buildEvents', { payload: state.slotmanagement_flights, context: context });
        context.commit('mut_filter_Flights'); // rebuild
        context.commit('mut_buildRotations');
        context.commit('mut_filter_Rotations');
        context.commit('mut_createWarnings');
        // Slots Table
        context.commit('mut_slotsTable_rebuildSlots', { payload: state.slotmanagement_slotsTable_getSlots, context: context });
        context.commit('mut_slotsTable_filterSlotsRotation'); // rebuild
    }

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions
};
